<div class="fill-height px-2 pb-2 d-flex justify-content-center px-lg-5 zx-px-big-xl">
  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
  </div>
  <!-- orders -------------------------------------------------------------------------------------------------------- orders -->
  <section *ngIf="!isLoading" class="w-100 d-flex flex-column">
    <!-- title -->
    <div class="w-100 d-flex justify-content-between align-items-center px-2 pt-1 pb-3 p-lg-3">
      <h6 class="mb-0 zx-text-medium fw-bold zx-text-sm-big">
        <span *ngIf="!isManagementView">
          {{ "main-nav.my-orders" | translate }}
        </span>
        <span *ngIf="isManagementView && user && user.email && user.email !== ''">
          <span *ngIf="orderIdFromRoute">
            {{ "su-management.order-of-user" | translate: { orderId: (orderIdFromRoute | slice : 0 : 8), email: user.email } }}
          </span>
          <span *ngIf="!orderIdFromRoute">
            <span *ngIf="isRTL">
              {{ "su-management.orders-of-user" | translate }}
            </span>
            <span *ngIf="user.email?.length > 0">{{
              user.email | slice : 0 : 25
              }}</span>
            <span *ngIf="user.email?.length > 25"> ... </span>
            <span *ngIf="!isRTL">
              {{ "su-management.orders-of-user" | translate }}
            </span>
          </span>
        </span>
      </h6>
    </div>

    <!-- orders accordion -->
    <mat-accordion #scrollContainer class="w-100 pb-3" multi="false" *ngIf="orders.length > 0 && !isLoading">
      <mat-expansion-panel *ngFor="let order of orders; index as o; trackBy: trackByOrderId"
        [expanded]="order._id === expandedPanelId && !isEmptyFixProductsPaymentOrder(order)"
        [attr.data-order-id]="order._id"
        [hideToggle]="isEmptyFixProductsPaymentOrder(order)" tabindex="0" role="button" class="my-tab-focus">
        <mat-expansion-panel-header (click)="togglePanel(order)"
          [class.zx-choosen-order]="expandedPanelId === order._id"
          [class.zx-choosen-order-solo]="expandedPanelId === order._id && isEmptyFixProductsPaymentOrder(order)"
          [class.zx-big-order-header]="!isAllFilesHavePaperSet(order)"
          [class.zx-inqlude-title-h]="lastPendingOrderIndex === o || o === 0" [class.orders-header]="isManagementView">
          <article class="w-100 d-flex flex-column">
            <!-- title -->
            <article *ngIf="lastPendingOrderIndex === o || o === 0"
              class="d-flex py-3 position-absolute top-0 w-100 zx-p-x-order-title"
              [class.zx-p-x-order-title-not-rtl]="!isRTL" [class.zx-p-x-order-title-darkmode]="isDarkMode">
              <h6 class="p-0 m-0 zx-text-small zx-text-sm-medium opacity-75">
                <!-- pending orders -->
                <b *ngIf="lastPendingOrderIndex > 0 && o === 0">
                  {{ "my-orders.pending-orders" + (isPHOrderExisting ? "-or-in-progress" : "") | translate }}
                </b>
                <!-- printed orders -->
                <b *ngIf="
                    lastPendingOrderIndex === 0 ||
                    (o > 0 && lastPendingOrderIndex + 1 > 0)
                  ">
                  {{ "my-orders.printed-orders" | translate }}
                </b>
              </h6>
            </article>
            <!-- // title -->

            <article class="w-100 d-flex align-items-center justify-content-between">
              <!-- ** main container ** -->
              <article class="d-flex flex-column flex-grow-1 gap-1 gap-lg-2 py-3">
                <!-- MAIN row -->

                <div class="d-flex row w-100 flex-row-reverse">
                  <!-- delete & maniger options -->
                  <div class="d-flex col-3 col-lg-1 align-items-lg-center justify-content-end"
                    [class.zx-move-delete-icon-ltr]="!isRTL && !isPHOrder(order)"
                    [class.zx-move-tree-dots]="isManagementView || (isPHOrder(order) && !isManagementView)"
                    [class.zx-move-tree-dots-not-rtl]="
                      (isManagementView || (isPHOrder(order) && !isManagementView)) && !isRTL
                    ">
                    <div *ngIf="isManagementView && order.status && order.status !== ''"
                         class="d-flex flex-column align-items-end justify-content-center">
                      <b class="px-2 px-sm-5 zx-order-status pb-2 pb-sm-0" [class.zx-order-status-not-rtl]="!isRTL" [class.zx-text-gray-dark-not-imp]="!isDarkMode &&
                        order.status !== 'PAID' &&
                        order.status !== 'IN_PRODUCTION' &&
                        order.status !== 'PROCESSING' &&
                        order.status !== 'INQUEUE' &&
                        order.status !== 'PRINTERQUEUE' &&
                        order.status !== 'DONE' &&
                        order.status !== 'FINISHED_PRODUCTION' &&
                        order.status !== 'FINISHED_SHIPMENT' &&
                        !(order.status === 'EXPIRED' || order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS' || order.status === 'CANCELLED' || order.status === 'ERROR')"
                        [class.text-red]="
                          (order.status === 'EXPIRED' ||
                            order.status === 'REFUNDED' ||
                            order.status === 'REFUNDED_POINTS' ||
                            order.status === 'CANCELLED' ||
                            order.status === 'ERROR') &&
                          !isDarkMode
                        " [class.text-green]="
                          order.status === 'PAID' ||
                          order.status === 'IN_PRODUCTION' ||
                          order.status === 'PROCESSING' ||
                          order.status === 'INQUEUE' ||
                          order.status === 'PRINTERQUEUE' ||
                          order.status === 'DONE' ||
                          order.status === 'FINISHED_PRODUCTION' ||
                          order.status === 'FINISHED_SHIPMENT'
                        ">
                        <span *ngIf="!order.isDeleted">
                          <ng-container *ngIf="order.status === 'REFUNDED'">
                            <span class="d-none d-sm-inline">{{ "my-orders.status.REFUNDED" | translate }}</span>
                            <span class="d-inline d-sm-none">{{ "my-orders.status.REFUNDED-short" | translate }}</span>
                          </ng-container>
                          <ng-container *ngIf="order.status !== 'REFUNDED'">
                            {{ "my-orders.status." + order.status | translate }}
                          </ng-container>
                        </span>
                        <span *ngIf="order.isDeleted" [class.text-red]="!isDarkMode">
                          {{ "my-orders.status.CANCELLED" | translate }}
                        </span>
                        <img *ngIf="isManagementView && hasPlotterPaperUsage(order)" #paperUsageTip="matTooltip"
                          src="assets/images/i-explain-icon.svg" alt=""
                          class="svg c-pointer align-middle mx-1" style="width: 16px; height: 16px;"
                          [matTooltip]="getPlotterPaperUsageTooltip(order)"
                          matTooltipClass="monitor-paper-tooltip" matTooltipPosition="above"
                          [matTooltipShowDelay]="0" [matTooltipHideDelay]="0"
                          (click)="stopEvent($event); isMobile && paperUsageTip.toggle()">
                      </b>
                    </div>

                    <!-- user options (delete) - לא PH; בקשת תשלום: רק לפני תשלום -->
                    <img *ngIf="!order.isDeleted &&
                        o < lastPendingOrderIndex &&
                        !isManagementView &&
                        !isPHOrder(order) &&
                        (!isEmptyFixProductsPaymentOrder(order) || isEmptyPaymentRequestPending(order))
                      " (click)="openDeleteOrderDialog($event, order)" [matTooltip]="'delete-order.title' | translate"
                      [matTooltipPosition]="'above'"
                      class="zx-small-icon-size zx-small-small-plus-icon-size-lg svg delete-on-hover opacity-50"
                      [class.bg-light-darkmode]="isDarkMode" [class.rounded-circle]="isDarkMode"
                      [src]="'assets/images/delete-icon.svg'" />
                    <!-- PH: 3 נקודות (צ'אט) – משתמש רגיל; ביטול הזמנה רק מצ'אט / לפני תשלום שם -->
                    <ng-container *ngIf="isPHOrder(order) && !isManagementView">
                      <button mat-icon-button color="secondary" class="rounded-pill zx-text-tiny small-btn p-0 opacity-50"
                        [matMenuTriggerFor]="phOrderUserMenu" (click)="stopEvent($event)">
                        <img class="zx-small-icon-size svg c-pointer" src="assets/images/three-dots-icon.svg"
                          alt="Image Options" />
                      </button>
                      <mat-menu #phOrderUserMenu="matMenu">
                        <button color="secondary" mat-menu-item
                          [routerLink]="['/chat/user', userChatUserId, order._id]" (click)="stopEvent($event)">
                          <div class="d-flex align-items-center gap-2 zx-ph-chat-menu-item">
                            <mat-icon class="zx-text-medium zx-text-sm-big flex-shrink-0 zx-menu-item-icon">chat</mat-icon>
                            <span class="flex-grow-1">{{ "ph-order-action.chat-with-machine-operator" | translate }}</span>
                          </div>
                        </button>
                      </mat-menu>
                    </ng-container>
                    <!-- // user options -->

                    <!-- maniger options -->
                    <!-- error -->
                    <div *ngIf="
                        isManagementView &&
                        order.hasErrors &&
                        order.hasErrors === true
                      " class="d-flex gap-1 gap-lg-2 opacity-50">
                      <div class="d-flex gap-1 text-red p-3" [matTooltip]="
                          'su-management.order-with-error' | translate
                        " [matTooltipPosition]="'above'">
                        <mat-icon class="zx-text-medium zx-text-sm-big text-red">warning</mat-icon>
                      </div>
                    </div>
                    <button *ngIf="isManagementView" mat-icon-button color="secondary"
                      class="rounded-pill zx-text-tiny small-btn p-0 opacity-50" [matMenuTriggerFor]="manigerManu"
                      (click)="stopEvent($event)">
                      <img class="zx-small-icon-size svg c-pointer" src="assets/images/three-dots-icon.svg"
                        alt="Image Options" />
                    </button>
                    <mat-menu #manigerManu="matMenu">
                      <!-- צור הצעת מחיר – ראשון בתפריט להזמנת PH ב-NOT_PAID (מנהל צופה בהזמנות משתמש) -->
                      <button *ngIf="isManagementView && isPHOrder(order) && order.status === 'NOT_PAID'" color="secondary" mat-menu-item
                        (click)="openCreatePriceQuoteDialog(order); $event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1 zx-ph-action-green">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">receipt_long</mat-icon>
                          <span class="d-flex flex-grow-1">{{ "ph-order-action.create-price-quote" | translate }}</span>
                        </div>
                      </button>
                      <!-- error -->
                      <div *ngIf="order.hasErrors && order.hasErrors === true" mat-icon-button class="d-flex">
                        <div class="d-flex flex-grow-1 gap-4 m-2 text-red" [matTooltip]="
                            'su-management.order-with-error' | translate
                          " [matTooltipPosition]="'above'">
                          <mat-icon class="zx-text-medium zx-text-sm-big text-red">warning</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{
                            "su-management.order-with-error"
                            | translate
                            | slice : 0 : 15
                            }}...
                          </span>
                        </div>
                      </div>
                      <!-- התחלתי לייצר / סיימתי לייצר / המשלוח הגיע – תמיד בראש התפריט -->
                      <button *ngIf="isPHOrder(order) && order.status === 'IN_PRODUCTION' && !(order.productionStartedAt || order.productionStarted)" color="secondary" mat-menu-item
                        (click)="onMarkProductionStarted(order); $event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1 zx-ph-action-green">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">play_circle</mat-icon>
                          <span class="d-flex flex-grow-1">{{ "ph-order-action.started-production" | translate }}</span>
                        </div>
                      </button>
                      <button *ngIf="isPHOrder(order) && (order.status === 'STARTED_PRODUCTION' || (order.status === 'IN_PRODUCTION' && (order.productionStartedAt || order.productionStarted)))" color="secondary" mat-menu-item
                        (click)="onMarkProductionFinished(order); $event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1 zx-ph-action-green">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">check_circle</mat-icon>
                          <span class="d-flex flex-grow-1">{{ "ph-order-action.finished-production" | translate }}</span>
                        </div>
                      </button>
                      <button *ngIf="isPHOrder(order) && order.status === 'FINISHED_PRODUCTION'" color="secondary" mat-menu-item
                        (click)="onMarkArrivedAtAddress(order); $event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1 zx-ph-action-green">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">local_shipping</mat-icon>
                          <span class="d-flex flex-grow-1">{{ "chat.arrived-at-address-menu" | translate }}</span>
                        </div>
                      </button>
                      <!-- chat with user - רק להזמנת PH -->
                      <button *ngIf="isPHOrder(order)" color="secondary" mat-menu-item
                        [routerLink]="['/chat/manager', order._id]"
                        (click)="$event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1 text-green">chat</mat-icon>
                          <span class="d-flex flex-grow-1 text-green d-none d-sm-inline">{{ "ph-order-action.chat-with-user" | translate }}</span>
                          <span class="d-flex flex-grow-1 text-green d-inline d-sm-none">{{ "chat.title" | translate }}</span>
                        </div>
                      </button>
                      <!-- זיכוי באשראי – רק להזמנת PH, לא בהזמנת מנהל, בסטטוסים שולמו -->
                      <button *ngIf="!order?.adminOrder && isPHOrder(order) && (order.status === 'IN_PRODUCTION' || order.status === 'STARTED_PRODUCTION' || order.status === 'FINISHED_PRODUCTION' || order.status === 'FINISHED_SHIPMENT') && order.status !== 'REFUNDED' && order.status !== 'REFUNDED_POINTS'"
                        color="secondary" mat-menu-item (click)="onOpenCreditOrderDialog(order, 'credit'); $event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">attach_money</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{ "credit-order.title-credit" | translate }}
                          </span>
                        </div>
                      </button>
                      <!-- זיכוי בנקודות – רק להזמנות שאינן PH, לא בהזמנת מנהל, בסטטוסים שולמו -->
                      <button *ngIf="!order?.adminOrder && !isPHOrder(order) && (order.status === 'IN_PRODUCTION' || order.status === 'STARTED_PRODUCTION' || order.status === 'FINISHED_PRODUCTION' || order.status === 'FINISHED_SHIPMENT') && order.status !== 'REFUNDED' && order.status !== 'REFUNDED_POINTS'"
                        color="secondary" mat-menu-item (click)="onOpenCreditOrderDialog(order, 'points'); $event.stopPropagation()">
                        <div class="d-flex align-items-center gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">money_off</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{ "credit-order.title-points" | translate }}
                          </span>
                        </div>
                      </button>
                      <!-- download all files - 3D: הורדה ישירה מ-fileUrl, אחר: תפריט -->
                      <button *ngIf="is3DOrder(order)" color="secondary" mat-menu-item
                        (click)="onDownloadAll3DFiles(order); $event.stopPropagation()">
                        <div class=" d-flex gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">cloud_download</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{
                            "su-management.users.download-files" | translate
                            }}
                          </span>
                        </div>
                      </button>
                      <ng-container *ngIf="!is3DOrder(order)">
                      <button color="secondary" mat-menu-item [matMenuTriggerFor]="downloadAllFilesManu">
                        <div class=" d-flex gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">cloud_download</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{
                            "su-management.users.download-files" | translate
                            }}
                          </span>
                        </div>
                      </button>
                      <mat-menu #downloadAllFilesManu="matMenu">
                        <!-- download ORIGINAL all files -->
                        <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                          (click)="onDownloadOrderOriginalFiles(getOrderFilesSystem(order), order, true); $event.stopPropagation()">
                          <b class="zx-text-small m-0">
                            {{'su-management.users.download-original' | translate}}
                          </b>
                          <mat-icon class="mx-1 p-0 zx-pt-small">crop_original</mat-icon>
                        </button>
                        <!-- download PROCESSED NOT SENT all files (express only) -->
                        <button *ngIf="getOrderFilesSystem(order) === 'express'" class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                          (click)="onDownloadOrderOriginalFiles(getOrderFilesSystem(order), order, 'processedNotSent'); $event.stopPropagation()">
                          <b class="zx-text-small m-0">
                            {{'su-management.users.download-processed-not-sent' | translate}}
                          </b>
                          <mat-icon class="mx-1 p-0 zx-pt-small">edit_note</mat-icon>
                        </button>
                        <!-- download PRINTED all files -->
                        <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                          [disabled]="order.status === 'PENDING'"
                          (click)="onDownloadOrderOriginalFiles(getOrderFilesSystem(order), order, false); $event.stopPropagation()">
                          <b class="zx-text-small m-0">
                            {{'su-management.users.download-printed' | translate}}
                          </b>
                          <mat-icon class="mx-1 p-0 zx-pt-small">file_copy</mat-icon>
                        </button>
                      </mat-menu>
                      </ng-container>
                      <!-- copy details -->
                      <button color="secondary" mat-menu-item (click)="
                          copyOrderDetails(order); $event.stopPropagation()
                        ">
                        <div class="d-flex gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">content_copy</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{ "su-management.copy-order-details" | translate }}
                          </span>
                        </div>
                      </button>
                      <!-- copy phone -->
                      <button *ngIf="getOrderPhone(order)" color="secondary" mat-menu-item
                        (click)="copyUserPhone(order); $event.stopPropagation()">
                        <div class="d-flex gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">content_copy</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{ "su-management.copy-phone" | translate }}
                          </span>
                        </div>
                      </button>
                      <button color="secondary" mat-menu-item
                        [disabled]="!orderHasPhoneForSms(order)"
                        [matTooltip]="'su-management.send-sms-to-user.disabled-no-phone-tooltip' | translate"
                        [matTooltipDisabled]="orderHasPhoneForSms(order)"
                        matTooltipPosition="above"
                        (click)="onSendSmsToUserFromOrder(order); $event.stopPropagation()">
                        <div class="d-flex gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">sms</mat-icon>
                          <span class="d-flex flex-grow-1">
                            {{ "su-management.users.send-sms-to-user" | translate }}
                          </span>
                        </div>
                      </button>
                      <!-- העתק מידע טכני – מצב מנהל (userorders): פלוטר, אקספרס, PH -->
                      <button color="secondary" mat-menu-item
                        (click)="copyTechnicalInfo(order); $event.stopPropagation()">
                        <div class="d-flex gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">content_copy</mat-icon>
                          <span class="d-flex flex-grow-1">{{ "ph-order-action.copy-technical-info" | translate }}</span>
                        </div>
                      </button>
                      <!-- resend-order -->
                      <button *ngIf="isOrderAddedToQueue(order) &&
                          !order.isDeleted &&
                          !(order.hasErrors && order.hasErrors === true)" mat-menu-item color="secondary"
                        class="small-btn" [matMenuTriggerFor]="resentOrderManu" (click)="stopEvent($event)">
                        <div class="d-flex align-items-center gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">refresh</mat-icon>
                          <span class="d-flex">
                            {{ "su-management.resend-order" | translate }}
                          </span>
                        </div>
                      </button>
                      <mat-menu #resentOrderManu="matMenu">
                        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                          (click)="resendOrder(order)">
                          <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ "su-management.resend-order" | translate }}
                          </b>
                          <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                            [class.zx-text-white]="isDarkMode">refresh</mat-icon>
                        </button>
                        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                          (click)="onOpenResendPartialFilesDialog(order); $event.stopPropagation()">
                          <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ "su-management.resend-partial-files" | translate }}
                          </b>
                          <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                            [class.zx-text-white]="isDarkMode">checklist</mat-icon>
                        </button>
                        <button *ngIf="getOrderFilesSystem(order) === 'express'" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                          mat-menu-item (click)="resendOrder(order, true)">
                          <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ "su-management.resend-order-force-rasterize" | translate }}
                          </b>
                          <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                            [class.zx-text-white]="isDarkMode">layers</mat-icon>
                        </button>
                        <button *ngIf="getOrderFilesSystem(order) === 'express'" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                          mat-menu-item (click)="onOpenResendPartialFilesDialog(order, true); $event.stopPropagation()">
                          <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{ "su-management.resend-partial-files-force-rasterize" | translate }}
                          </b>
                          <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                            [class.zx-text-white]="isDarkMode">layers</mat-icon>
                        </button>
                      </mat-menu>
                      <!-- refund-order -->
                      <button *ngIf="
                          (isOrderAddedToQueue(order) ||
                            order.is_only_fix_products_in_order) &&
                          !order.isDeleted &&
                          order.status !== 'REFUNDED'
                        " mat-menu-item color="secondary" class="small-btn" [matMenuTriggerFor]="refundOrderManu"
                        (click)="stopEvent($event)">
                        <div class="d-flex align-items-center gap-1">
                          <mat-icon class="zx-text-medium zx-text-sm-big pt-1">money_off</mat-icon>
                          <span class="d-flex">
                            {{ "su-management.cancel-order" | translate }}
                          </span>
                        </div>
                      </button>
                      <mat-menu #refundOrderManu="matMenu">
                        <button *ngIf="
                            !order?.adminOrder &&
                            !isPHOrder(order) &&
                            order.status !== 'REFUNDED_POINTS' &&
                            !order.fix_products_order
                          " class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                          (click)="onOpenCreditOrderDialog(order, 'points'); $event.stopPropagation()">
                          <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{
                            "su-management.cancel-order.REFUNDED_POINTS"
                            | translate
                            }}
                          </b>
                          <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                            [class.zx-text-white]="isDarkMode">money_off</mat-icon>
                        </button>
                        <button *ngIf="!order?.adminOrder && order.ccCost > 0" class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                          (click)="onOpenCreditOrderDialog(order, 'credit'); $event.stopPropagation()">
                          <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                            {{
                            "su-management.cancel-order.REFUNDED" | translate
                            }}
                          </b>
                          <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                            [class.zx-text-white]="isDarkMode">attach_money</mat-icon>
                                </button>
                              </mat-menu>
                              <!-- delete order; PH: גם בסטטוס הצעת מחיר נשלחה טרם אושרה (IN_QUOTATION) -->
                              <button *ngIf="!order.isDeleted && o < lastPendingOrderIndex &&
                                (!isPHOrder(order) || order.status === 'NOT_PAID' || order.status === 'IN_QUOTATION')" color="secondary" mat-menu-item
                                (click)="openDeleteOrderDialog($event, order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1 text-red">delete_outline</mat-icon>
                                  <span class="d-flex flex-grow-1 text-red">
                                    {{ "delete-order.title" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- בדוק שגיאות חיוב -->
                              <button color="secondary" mat-menu-item
                                (click)="onCheckBillingErrors(order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">receipt_long</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.check-billing-errors-menu" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- הצג נתוני כיסוי – אקספרס בלבד, SU במצב מנהל -->
                              <button *ngIf="isManagementView && isSU && getOrderFilesSystem(order) === 'express' && !isPHOrder(order) && getInkGradientEligibleFiles(order).length === 1"
                                color="secondary" mat-menu-item
                                (click)="openInkGradientDialogForFile(getInkGradientEligibleFiles(order)[0], order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">gradient</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.show-cover-data-menu" | translate }}
                                  </span>
                                </div>
                              </button>
                              <button *ngIf="isManagementView && isSU && getOrderFilesSystem(order) === 'express' && !isPHOrder(order) && getInkGradientEligibleFiles(order).length > 1"
                                color="secondary" mat-menu-item [matMenuTriggerFor]="inkGradientFilesMenu">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">gradient</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.show-cover-data-menu" | translate }}
                                  </span>
                                </div>
                              </button>
                              <mat-menu #inkGradientFilesMenu="matMenu">
                                <button *ngFor="let file of getInkGradientEligibleFiles(order)" class="d-flex align-items-center gap-1 px-2"
                                  mat-menu-item [class.zx-ltr]="!isRTL"
                                  (click)="openInkGradientDialogForFile(file, order); $event.stopPropagation()">
                                  <b class="zx-text-small m-0 text-break">
                                    {{ getDisplayFileNameAfterSplit(file) | slice:0:40 }}
                                  </b>
                                </button>
                              </mat-menu>
                              <!-- בדיקת PrintNode – אקספרס בלבד (מנהל), תמיד אחרון בתפריט -->
                              <button *ngIf="isManagementView && getOrderFilesSystem(order) === 'express'" color="secondary" mat-menu-item
                                (click)="onCheckPrintNodeStatus(order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">fact_check</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.printnode-check-menu" | translate }}
                                  </span>
                                </div>
                              </button>
                            </mat-menu>
                            <!-- // maniger options -->
                  </div>
                  <!-- // delete & maniger options -->

                  <!-- files and price -->
                  <div class="col-12 col-lg-2 zx-text-small d-flex flex-column justify-content-md-center">
                    <span *ngIf="isEmptyFixProductsPaymentOrder(order)">
                      {{ roundDownTowDecimal(getEmptyPaymentRequestAmount(order)) }}
                      <span class="zx-text-tiny">
                        {{ "printing-table.nis" | translate }}
                      </span>
                    </span>
                    <span *ngIf="!isEmptyFixProductsPaymentOrder(order)">
                      <!-- files -->
                      <span *ngIf="!order.is_only_fix_products_in_order">
                        <span *ngIf="
                            getExpressFileDisplayCount(order) > 1 ||
                            !order.files || order.files.length === 0
                          ">
                          <span>
                            {{ getExpressFileDisplayCount(order) }}
                          </span>
                          <span>
                            {{ "printing-table.files" | translate }}
                          </span>
                        </span>
                        <span *ngIf="getExpressFileDisplayCount(order) === 1">
                          <span>
                            {{ "printing-table.one-file" | translate }}
                          </span>
                        </span>
                      </span>
                      <!-- , -->
                      <span *ngIf="
                          order.fix_products_order?.products?.length > 0 &&
                          order.files?.length > 0
                        ">,
                      </span>
                      <!-- fix products -->
                      <span *ngIf="order.fix_products_order?.products?.length > 0">
                        <span *ngIf="
                            getAmountOfFixProducts(
                              order.fix_products_order.products
                            ) > 1
                          ">
                          <span>
                            {{
                            getAmountOfFixProducts(
                            order.fix_products_order.products
                            )
                            }}
                          </span>
                          <span>
                            {{
                            "fix-products.num-of-products.many" | translate
                            }}
                          </span>
                        </span>
                        <span *ngIf="
                            getAmountOfFixProducts(
                              order.fix_products_order.products
                            ) === 1
                          ">
                          <span>
                            {{ "fix-products.num-of-products.one" | translate }}
                          </span>
                        </span>
                      </span>
                      <!-- , -->
                      <span>, </span>
                      <!-- PH עם הצעת מחיר לא מבוטלת או עם totalCost (באק) – מציג מחיר -->
                      <span *ngIf="isPHOrder(order) && hasPHOrderDisplayPrice(order) && getPHOrderTotalForDisplay(order) != null" class="zx-text-small">
                        {{ getPHOrderTotalForDisplay(order) }}
                        {{ "printing-table.nis" | translate }}
                      </span>
                      <!-- PH בלי מחיר לתצוגה – ממתינה להצעת מחיר -->
                      <span *ngIf="isPHOrder(order) && !hasPHOrderDisplayPrice(order)" class="zx-text-small">
                        {{ "my-orders.waiting-for-pricing" | translate }}
                      </span>
                      <!-- before discount price - order discounted -->
                      <span class="opacity-75" *ngIf="!isPHOrder(order) &&
                          order.discount &&
                          order.discount > .001 &&
                          !order.adminOrder
                        ">
                        <span class="strikethrough">
                          <span>
                            {{
                            roundDownTowDecimal(
                            order.totalCost +
                            order.discount +
                            getOrderFixProductsPrice(order)
                            )
                            }}
                          </span>
                          <span>
                            {{ "printing-table.nis" | translate }}
                          </span>
                        </span>
                        <span class="zx-100-opacity">.</span>
                        <span class="zx-text-tiny text-green">
                          <span>( %</span>
                          <span>
                            {{
                            roundDownTowDecimal(
                            100 -
                            ((order.totalCost +
                            order.discount -
                            order.discount) /
                            (order.totalCost + order.discount)) *
                            100
                            )
                            }}
                          </span>
                          <span>
                            {{ "my-orders.discount" | translate }}
                          </span>
                          <span>)</span>
                        </span>
                        <span class="zx-100-opacity">.</span>
                      </span>
                      <!-- normal user (לא להזמנות PH – מטופל למעלה) -->
                      <span *ngIf="!order.adminOrder && !isPHOrder(order)">
                        <!-- total cost -->
                        <span *ngIf="
                            !isOrderAddedToQueue(order) &&
                            (!user.points ||
                              (user.points && user.points === 0)) &&
                            (!user.discount || user.discount === 0)
                          ">
                          {{
                          roundDownTowDecimal(
                          order.totalCost + getOrderFixProductsPrice(order)
                          )
                          }}
                        </span>
                        <span *ngIf="isOrderAddedToQueue(order)">
                          {{
                          roundDownTowDecimal(
                          order.ccCost + getOrderFixProductsPrice(order)
                          )
                          }}
                        </span>
                        <span *ngIf="
                            !isOrderAddedToQueue(order) &&
                            (!user.discount || user.discount === 0)
                          ">
                          <span *ngIf="
                              user.points > 0 && order.totalCost > user.points
                            ">
                            {{
                            roundDownTowDecimal(
                            order.totalCost -
                            user.points +
                            getOrderFixProductsPrice(order)
                            )
                            }}
                          </span>
                          <span *ngIf="
                              user.points > 0 && order.totalCost <= user.points
                            ">
                            {{ getOrderFixProductsPrice(order) }}
                          </span>
                        </span>
                        <span *ngIf="
                            !isOrderAddedToQueue(order) &&
                            user.discount > 0 &&
                            !order.adminOrder
                          ">
                          <span *ngIf="!user.points || user.points === 0">
                            {{
                            roundDownTowDecimal(
                            order.totalCost +
                            getOrderFixProductsPrice(order)
                            )
                            }}
                          </span>
                          <span *ngIf="user.points > 0">
                            <span *ngIf="
                                user.points > 0 &&
                                order.totalCost >= user.points
                              ">
                              {{
                              roundDownTowDecimal(
                              order.totalCost -
                              user.points +
                              getOrderFixProductsPrice(order)
                              )
                              }}
                            </span>
                            <span *ngIf="
                                user.points > 0 && order.totalCost < user.points
                              ">
                              {{ getOrderFixProductsPrice(order) }}
                            </span>
                          </span>
                        </span>
                        <span class="zx-text-tiny">
                          {{ "printing-table.nis" | translate }}
                        </span>
                        <!-- points cost - not printed -->
                        <span *ngIf="
                            !isOrderAddedToQueue(order) &&
                            user.points &&
                            user.points > 0 &&
                            !order.adminOrder
                          ">
                          <span>
                            {{ "my-orders.and" | translate }}
                          </span>
                          <span *ngIf="order.totalCost > user.points">
                            {{ roundDownTowDecimal(user.points) }}
                          </span>
                          <span *ngIf="order.totalCost <= user.points">
                            {{ roundDownTowDecimal(order.totalCost) }}
                          </span>
                          <span class="zx-text-tiny">
                            {{ "printing-table.points-short" | translate }}
                          </span>
                        </span>
                        <!-- points cost - printed -->
                        <span *ngIf="
                            isOrderAddedToQueue(order) &&
                            order.pointsCost &&
                            order.pointsCost > 0 &&
                            !order.adminOrder
                          ">
                          <span>
                            {{ "my-orders.and" | translate }}
                          </span>
                          <span>
                            {{ roundDownTowDecimal(order.pointsCost) }}
                          </span>
                          <span class="zx-text-tiny">
                            {{ "printing-table.points-short" | translate }}
                          </span>
                        </span>
                        <!-- didnt charge? -->
                        <span class="zx-text-tiny text-green fw-bold" *ngIf="
                            !isOrderAddedToQueue(order) &&
                            !order.adminOrder &&
                            !order.is_only_fix_products_in_order
                          ">
                          <span class="zx-100-opacity">-</span>
                          <span>(</span>
                          <span>
                            {{ "my-orders.didnt-charge" | translate }}
                          </span>
                          <span>)</span>
                        </span>
                      </span>
                      <!-- manager user - admin order -->
                      <span *ngIf="order.adminOrder && !is3DOrder(order)">
                        <span>
                          {{
                          roundDownTowDecimal(
                          order.totalCost + getOrderFixProductsPrice(order)
                          )
                          }}
                        </span>
                        <span class="zx-text-tiny">
                          {{ "printing-table.nis" | translate }}
                        </span>
                      </span>

                      <!-- manager user - admin order -->
                      <span *ngIf="order.adminOrder && !order.resentData?.originalOrderId">
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny zx-text-pink fw-bold"
                          [class.zx-text-white]="isDarkMode">
                          <span class="zx-100-opp">_</span>
                          <span>
                            {{ "my-orders.manager-order" | translate }}
                          </span>
                        </span>
                      </span>
                      <!-- resent order - duplicated admin order -->
                      <span *ngIf="order.resentData?.originalOrderId">
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny zx-text-pink fw-bold"
                          [class.zx-text-white]="isDarkMode">
                          <span class="zx-100-opp">_</span>
                          <span>
                            {{ "my-orders.resent-manager-order" | translate }}
                          </span>
                        </span>
                      </span>
                      <span *ngIf="isManagementView && order.branchID?.is_express && order.maybeNotPrinting"
                        class="zx-text-tiny-tiny fw-bold text-nowrap ms-1"
                        style="color: var(--zx-pink);">
                        &nbsp;{{ "my-orders.maybe-not-printed" | translate }}
                      </span>
                      <!-- // manager user - admin order -->
                    </span>

                  </div>
                  <!-- // files and price -->

                  <!-- place -->
                  <article *ngIf="isEmptyFixProductsPaymentOrder(order)"
                    class="d-flex flex-column justify-content-md-center col-12 col-lg-3 py-2">
                    <div class="d-flex w-100 align-items-center">
                      <span class="zx-text-small c-pointer fw-bold">
                        {{ "my-orders.empty-payment-request.place-label" | translate }}
                      </span>
                    </div>
                  </article>
                  <article *ngIf="!isEmptyFixProductsPaymentOrder(order)"
                    class="d-flex flex-column justify-content-md-center col-12 col-lg-3 py-2">
                    <div class="d-flex w-100 align-items-center gap-2">
                      <img *ngIf="!order.branchID?.is_express && !isPHOrder(order)"
                        [src]="'assets/images/plotter-icon.svg'" alt="choosen printing system icon"
                        class="zx-small-icon-size c-pointer" />
                      <img *ngIf="order.branchID?.is_express && !isPHOrder(order)" [src]="
                        'assets/images/' +
                        getIsPics(order.printerID) +
                        '-icon.svg'
                      " alt="choosen printing system icon" class="zx-small-icon-size c-pointer" />
                      <img *ngIf="!order.branchID?.is_express && !isPHOrder(order)" [src]="
                        'assets/images/branches/' +
                        order.branchID?.serial_name +
                        '.png'
                      " alt="branch icon" class="zx-small-icon-size c-pointer" />
                      <img *ngIf="order.branchID?.is_express && !isPHOrder(order)" [src]="
                        'assets/images/branches/' +
                        order.printerID?.serial_name +
                        '.png'
                      " alt="branch icon" class="zx-small-icon-size c-pointer" />
                      <!-- ph: phprint vs 3dprint – כמו סיכום הזמנה -->
                      <img *ngIf="isPHOrder(order)" [src]="getPhSystemIconSrcForOrder(order)" alt=""
                        class="zx-small-icon-size c-pointer" />
                      <img *ngIf="isPHOrder(order)" [src]="
                        'assets/images/products/' +
                        order.productID.name +
                        '.svg'
                      " alt="product icon" class="zx-small-icon-size c-pointer" />
                      <!-- // ph -->
                      <div class="d-flex align-items-center">
                        <span class="zx-text-small c-pointer">
                          <span *ngIf="!order.branchID?.is_express && !isPHOrder(order)">
                            {{
                            "choose-branch.naming.plotter." +
                            order.branchID?.serial_name | translate
                            }}
                          </span>
                          <span *ngIf="order.branchID?.is_express && !isPHOrder(order)">
                            {{
                            "choose-branch.naming.express." +
                            order.printerID?.serial_name | translate
                            }}
                          </span>
                          <!-- ph -->
                          <span *ngIf="isPHOrder(order)">
                            <span>
                              {{
                              "choose-product.naming." +
                              order.productID.name | translate
                              }}
                            </span>
                            <span>, </span>
                            <span>
                              {{ "collect.from." +
                              (order.collectionData?.selectedCollectOption === 'delivery' ? 'delivery' : 'pickup')
                              | translate }}{{order.collectionData?.selectedCollectOption !== 'delivery' ?
                              getPlaceDisplayName(order.selectedPlace || order.collectionData?.selectedPlace) : '' }}
                            </span>
                          </span>
                          <!-- // ph -->
                        </span>
                      </div>
                    </div>
                  </article>

                  <!-- status and times -->
                  <div class="d-flex col-12 col-lg-6 align-items-center px-3">
                    <div class="d-flex align-items-center w-100 rounded-pill bg-white-50-pr shadow-85-light"
                      [class.border-2]="order.resentData?.originalOrderId"
                      [style.border-color]="order.resentData?.originalOrderId ? 'var(--zx-pink)' : null">

                      <!-- PH IN_PRODUCTION – 3 שלבים: נשלחה | הצעת מחיר | שולמה -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'IN_PRODUCTION' && order.files && order.files.length > 0 && !order.isDeleted">
                        <div class="d-flex justify-content-center zx-status-con-33-p">
                          <div class="d-flex flex-column">
                            <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.sent" | translate }}</b>
                            <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                        <div class="d-flex justify-content-center zx-status-con-33-p">
                          <div class="d-flex flex-column">
                            <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.status.IN_QUOTATION" | translate }}</b>
                            <div *ngIf="getLastPriceQuoteForOrder(order)?.createdAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
<div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                        <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                                <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                            <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // PH IN_PRODUCTION -->

                      <!-- PH STARTED_PRODUCTION – אותו מבנה כמו FINISHED_PRODUCTION, טקסט "הייצור התחיל" + productionStartedAt -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'STARTED_PRODUCTION' && order.files && order.files.length > 0 && !order.isDeleted">
                        <div *ngIf="isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.status.IN_QUOTATION" | translate }}</b>
                              <div *ngIf="getLastPriceQuoteForOrder(order)?.createdAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-started" | translate }}</b>
                              <div *ngIf="order.productionStartedAt || order.productionStarted" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ (order.productionStartedAt || order.productionStarted) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ (order.productionStartedAt || order.productionStarted) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="!isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-started" | translate }}</b>
                              <div *ngIf="order.productionStartedAt || order.productionStarted" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ (order.productionStartedAt || order.productionStarted) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ (order.productionStartedAt || order.productionStarted) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // PH STARTED_PRODUCTION -->

                      <!-- PH FINISHED_PRODUCTION – 4 שלבים: נוצרה | אושרה ללא חיוב/שולמה | הייצור התחיל | הייצור הסתיים. 3 שלבים: נוצרה | אושרה ללא חיוב/שולמה | הייצור הסתיים -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'FINISHED_PRODUCTION' && order.files && order.files.length > 0 && !order.isDeleted">
                        <!-- גרסה 4 שלבים -->
                        <div *ngIf="isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-started" | translate }}</b>
                              <div *ngIf="order.productionStartedAt || order.productionStarted" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ (order.productionStartedAt || order.productionStarted) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ (order.productionStartedAt || order.productionStarted) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-finished" | translate }}</b>
                              <div *ngIf="order.productionFinishedAt || order.productionFinished" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- גרסה 3 שלבים -->
                        <div *ngIf="!isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-finished" | translate }}</b>
                              <div *ngIf="order.productionFinishedAt || order.productionFinished" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // PH FINISHED_PRODUCTION -->

                      <!-- PH FINISHED_SHIPMENT – 4 שלבים (בלי הצעת מחיר): נשלחה | שולמה | הייצור הסתיים | הגיע ליעד -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'FINISHED_SHIPMENT' && order.files && order.files.length > 0 && !order.isDeleted">
                        <!-- 4 שלבים: נשלחה | שולמה | הייצור הסתיים | הגיע ליעד -->
                        <div *ngIf="isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.sent" | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-finished" | translate }}</b>
                              <div *ngIf="order.productionFinishedAt || order.productionFinished" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.isCollected ? "my-orders.ph-timeline.arrived-and-collected" : "chat.arrived-at-destination") | translate }}</b>
                              <div *ngIf="order.shipmentFinishedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.shipmentFinishedAt | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.shipmentFinishedAt | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- 3 שלבים (מסכים קטנים): נוצרה | נשלחה | הגיע ליעד -->
                        <div *ngIf="!isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.sent" | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.isCollected ? "my-orders.ph-timeline.arrived-and-collected" : "chat.arrived-at-destination") | translate }}</b>
                              <div *ngIf="order.shipmentFinishedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.shipmentFinishedAt | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.shipmentFinishedAt | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // PH FINISHED_SHIPMENT -->

                      <!-- PH REFUNDED – 4 שלבים אם הייצור הסתיים (נוצרה | שולמה | הייצור הסתיים | זוכתה), 3 במסכים קטנים; אחרת 3 שלבים (נוצרה | שולמה | זוכתה) -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'REFUNDED'">
                        <!-- גרסה 4 שלבים כשהייצור הסתיים (או 3 אם לא), לפי isPhTimeline4Steps -->
                        <div *ngIf="isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center" [ngClass]="(order.productionFinishedAt || order.productionFinished) ? 'zx-status-con-25-p' : 'zx-status-con-33-p'">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center" [ngClass]="(order.productionFinishedAt || order.productionFinished) ? 'zx-status-con-25-p' : 'zx-status-con-33-p'">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <ng-container *ngIf="order.productionFinishedAt || order.productionFinished">
                            <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                            <div class="d-flex justify-content-center zx-status-con-25-p">
                              <div class="d-flex flex-column">
                                <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.production-finished" | translate }}</b>
                                <div *ngIf="order.productionFinishedAt || order.productionFinished" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                  <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "dd/MM/yy" }}</span>
                                  <span class="zx-text-tiny">{{ (order.productionFinishedAt || order.productionFinished) | date : "HH:mm" }}</span>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center" [ngClass]="(order.productionFinishedAt || order.productionFinished) ? 'zx-status-con-25-p' : 'zx-status-con-33-p'">
                          <div class="d-flex flex-column align-items-center justify-content-center">
                            <b class="zx-text-tiny zx-text-sm-small text-green text-center">{{ "my-orders.ph-timeline.credited" | translate }}</b>
                            <div *ngIf="order.creditedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ order.creditedAt | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ order.creditedAt | date : "HH:mm" }}</span>
                            </div>
                          </div>
                          </div>
                        </div>
                        <!-- גרסה 3 שלבים (הייצור הסתיים נעלם) -->
                        <div *ngIf="!isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ (order.adminOrder ? 'my-orders.ph-timeline.paid-admin' : 'my-orders.ph-timeline.paid') | translate }}</b>
                              <div *ngIf="getPHOrderPaidDate(order)" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ getPHOrderPaidDate(order) | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                          <div class="d-flex flex-column align-items-center justify-content-center">
                            <b class="zx-text-tiny zx-text-sm-small text-green text-center">{{ "my-orders.ph-timeline.credited" | translate }}</b>
                            <div *ngIf="order.creditedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ order.creditedAt | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ order.creditedAt | date : "HH:mm" }}</span>
                            </div>
                          </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // PH REFUNDED -->

                      <!-- פלוטר/אקספרס שהודפסו וזוכו – 4 שלבים (נוצרה | נשלחה | הודפסה | זוכתה) או 3 (נוצרה | הודפסה | זוכתה) לפי isPhTimeline4Steps; רק כשיש מועד הדפסה (print_end) -->
                      <ng-container *ngIf="!isPHOrder(order) && (order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS') && isOrderAddedToQueue(order) && hasOrderPrintedTime(order)">
                        <div *ngIf="isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.sent" | translate }}</b>
                              <div *ngIf="order.addedToQueue" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.addedToQueue | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.addedToQueue | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.printed" | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <ng-container *ngIf="!order.branchID?.is_express">
                                  <span class="zx-text-tiny">{{ order.print_end | date : "dd/MM/yy" }}</span>
                                  <span class="zx-text-tiny">{{ order.print_end | date : "HH:mm" }}</span>
                                </ng-container>
                                <ng-container *ngIf="order.branchID?.is_express">
                                  <span class="zx-text-tiny">{{ isOrderAddedToQueue(order) | date : "dd/MM/yy" }}</span>
                                  <span class="zx-text-tiny">{{ addSecondsToDate(isOrderAddedToQueue(order), order.files?.length || 0) | date : "HH:mm" }}</span>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-25-p">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                              <b class="zx-text-tiny zx-text-sm-small text-green text-center">{{ (order.status === 'REFUNDED_POINTS' ? 'my-orders.ph-timeline.credited-points' : 'my-orders.ph-timeline.credited') | translate }}</b>
                              <span *ngIf="order.status === 'REFUNDED_POINTS'" class="zx-text-tiny-tiny text-green text-center">{{ "my-orders.order-refunded-explain.points" | translate }}</span>
                              <div *ngIf="order.creditedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50 justify-content-center">
                                <span class="zx-text-tiny">{{ order.creditedAt | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.creditedAt | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="!isPhTimeline4Steps" class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.printed" | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <ng-container *ngIf="!order.branchID?.is_express">
                                  <span class="zx-text-tiny">{{ order.print_end | date : "dd/MM/yy" }}</span>
                                  <span class="zx-text-tiny">{{ order.print_end | date : "HH:mm" }}</span>
                                </ng-container>
                                <ng-container *ngIf="order.branchID?.is_express">
                                  <span class="zx-text-tiny">{{ isOrderAddedToQueue(order) | date : "dd/MM/yy" }}</span>
                                  <span class="zx-text-tiny">{{ addSecondsToDate(isOrderAddedToQueue(order), order.files?.length || 0) | date : "HH:mm" }}</span>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                              <b class="zx-text-tiny zx-text-sm-small text-green text-center">{{ (order.status === 'REFUNDED_POINTS' ? 'my-orders.ph-timeline.credited-points' : 'my-orders.ph-timeline.credited') | translate }}</b>
                              <span *ngIf="order.status === 'REFUNDED_POINTS'" class="zx-text-tiny-tiny text-green text-center">{{ "my-orders.order-refunded-explain.points" | translate }}</span>
                              <div *ngIf="order.creditedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50 justify-content-center">
                                <span class="zx-text-tiny">{{ order.creditedAt | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.creditedAt | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // פלוטר/אקספרס הודפסו וזוכו -->

                      <!-- פלוטר/אקספרס שזוכו אבל לא הודפסו (אין print_end) – 3 שלבים: נוצרה | נשלחה | זוכתה -->
                      <ng-container *ngIf="!isPHOrder(order) && (order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS') && isOrderAddedToQueue(order) && !hasOrderPrintedTime(order)">
                        <div class="d-flex align-items-center w-100">
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">{{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}</b>
                              <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column">
                              <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.ph-timeline.sent" | translate }}</b>
                              <div *ngIf="order.addedToQueue" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                <span class="zx-text-tiny">{{ order.addedToQueue | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.addedToQueue | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                          <div class="d-flex justify-content-center zx-status-con-33-p">
                            <div class="d-flex flex-column align-items-center justify-content-center">
                              <b class="zx-text-tiny zx-text-sm-small text-green text-center">{{ (order.status === 'REFUNDED_POINTS' ? 'my-orders.ph-timeline.credited-points' : 'my-orders.ph-timeline.credited') | translate }}</b>
                              <span *ngIf="order.status === 'REFUNDED_POINTS'" class="zx-text-tiny-tiny text-green text-center">{{ "my-orders.order-refunded-explain.points" | translate }}</span>
                              <div *ngIf="order.creditedAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50 justify-content-center">
                                <span class="zx-text-tiny">{{ order.creditedAt | date : "dd/MM/yy" }}</span>
                                <span class="zx-text-tiny">{{ order.creditedAt | date : "HH:mm" }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <!-- // פלוטר/אקספרס זוכו בלי הדפסה -->

                      <!-- PH בוטלה: נוצרה (שליש) | חץ | הזמנה בוטלה (שני שליש) -->
                      <ng-container *ngIf="isPhOrderCancelled(order)">
                        <div class="d-flex justify-content-center zx-status-con-33-p">
                          <div class="d-flex flex-column">
                            <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">
                              {{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}
                            </b>
                            <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ order.created | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ order.created | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                        <div class="d-flex justify-content-center align-items-center zx-status-con-66-p">
                          <b class="zx-text-tiny zx-text-sm-small text-red text-center" [class.zx-text-white]="isDarkMode">{{ "my-orders.ph-timeline.order-cancelled" | translate }}</b>
                        </div>
                      </ng-container>

                      <!-- created / duplicated (לא ב-IN_PRODUCTION / FINISHED_PRODUCTION / FINISHED_SHIPMENT / REFUNDED של PH, ולא פלוטר/אקספרס שהודפסו וזוכו; לא הזמנת PH בוטלה – יש בלוק ייעודי) -->
                      <ng-container *ngIf="!isPhOrderCancelled(order) && !(isPHOrder(order) && order.status === 'IN_PRODUCTION' && order.files && order.files.length > 0 && !order.isDeleted) && !(isPHOrder(order) && order.status === 'STARTED_PRODUCTION' && order.files && order.files.length > 0 && !order.isDeleted) && !(isPHOrder(order) && order.status === 'FINISHED_PRODUCTION' && order.files && order.files.length > 0 && !order.isDeleted) && !(isPHOrder(order) && order.status === 'FINISHED_SHIPMENT' && order.files && order.files.length > 0 && !order.isDeleted) && !(isPHOrder(order) && order.status === 'REFUNDED') && !(!isPHOrder(order) && (order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS') && isOrderAddedToQueue(order))">
                      <div class="d-flex justify-content-center zx-status-con-30-p">
                        <div class="d-flex flex-column">
                          <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">
                            {{ (order.resentData?.originalOrderId ? "my-orders.duplicated" : "my-orders.created") | translate }}
                          </b>
                          <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                            <span class="zx-text-tiny">
                              {{ order.created | date : "dd/MM/yy" }}
                            </span>
                            <span class="zx-text-tiny">
                              {{ order.created | date : "HH:mm" }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- // created -->

                      <!-- >>> -->
                      <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                      </ng-container>

                      <!-- PH – אין עדיין הצעת מחיר: ממתינה להצעת מחיר (שליש) + כפתור צ'אט עם המפעל (שליש), בלי משפט זמן -->
                      <ng-container *ngIf="isPHOrder(order) && order.files && order.files.length > 0 && !order.isDeleted && !getLastPriceQuoteForOrder(order) && (order.status === 'IN_QUOTATION' || order.status === 'NOT_PAID')">
                        <div class="d-flex justify-content-center zx-status-con-33-p align-items-stretch" [class.text-end]="isRTL" [class.text-start]="!isRTL">
                          <div class="d-flex flex-column justify-content-center" style="min-width: 0;">
                            <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.waiting-for-pricing" | translate }}</b>
                          </div>
                        </div>
                        <div class="d-flex flex-column flex-shrink-0 zx-status-con-33-p px-2 justify-content-center">
                          <button mat-raised-button color="primary" class="print-button rounded-pill d-flex align-items-center justify-content-center w-100"
                            (click)="navigateToChat(order)">
                            <span class="zx-text-sm-small text-white d-none d-sm-inline">{{ (isManagementView ? "ph-order-action.chat-with-user" : "my-orders.chat-with-factory") | translate }}</span>
                            <span class="zx-text-sm-small text-white d-inline d-sm-none">{{ "chat.title" | translate }}</span>
                          </button>
                        </div>
                      </ng-container>

                      <!-- sent to print? -->
                      <!-- empty payment request – אישור ותשלום / התשלום בוצע -->
                      <div *ngIf="isEmptyPaymentRequestPending(order)"
                        class="d-flex flex-column flex-shrink-0 zx-status-con-70-p px-3">
                        <button mat-raised-button color="primary" class="print-button rounded-pill d-flex"
                          (click)="openEmptyPaymentRequestSummaryDialog($event, order)">
                          <span class="zx-text-sm-small text-white">
                            {{ "my-orders.empty-payment-request.approve-and-pay" | translate }}
                          </span>
                        </button>
                      </div>
                      <div *ngIf="isEmptyPaymentRequestPaid(order)"
                        class="d-flex justify-content-center zx-status-con-70-p">
                        <div class="d-flex flex-column text-center">
                          <b class="zx-text-tiny zx-text-sm-small text-green">
                            {{ "my-orders.empty-payment-request.payment-done" | translate }}
                          </b>
                          <div *ngIf="getEmptyPaymentRequestPaidAt(order) as paidAt"
                            class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50 justify-content-center">
                            <span class="zx-text-tiny">{{ paidAt | date : "dd/MM/yy" }}</span>
                            <span class="zx-text-tiny">{{ paidAt | date : "HH:mm" }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- NO, BUT POSSIBLE! (sent to print?) – לא להזמנת PH שעדיין אין לה הצעת מחיר (רואים בלוק למעלה) -->
                      <div *ngIf="
                          !isEmptyFixProductsPaymentOrder(order) &&
                          !isOrderAddedToQueue(order) &&
                          (order.status === 'PENDING' ||
                            order.status === 'QR' ||
                            order.status === 'NOT_PAID') &&
                          (!order.files || order.files.length > 0) &&
                          !order.isDeleted &&
                          !(isPHOrder(order) && !getLastPriceQuoteForOrder(order) && (order.status === 'IN_QUOTATION' || order.status === 'NOT_PAID'))
                        " class="d-flex flex-column flex-shrink-0 zx-status-con-70-p px-3">
                        <!-- [print btn] - בהזמנת PH/3D ב-NOT_PAID: מציגים זמן במקום כפתור (לא ניתן לשלוח להדפסה לפני תשלום) -->
                        <ng-container *ngIf="!(order.collectionData && order.status === 'NOT_PAID')">
                        <button mat-raised-button color="primary" class="print-button rounded-pill d-flex"
                          (click)="openOrderSummaryDialog($event, order)">
                          <span class="zx-text-sm-small text-white">
                            {{ "printing-table.send-to-print" | translate }}
                          </span>
                        </button>
                        </ng-container>
                        <div *ngIf="order.collectionData && order.status === 'NOT_PAID'"
                          class="d-flex flex-column flex-grow-1 px-3 gap-1 gap-lg-2 w-100">
                          <span class="zx-text-tiny opacity-50 text-sm-center d-block w-100">{{ getCommitmentTimeText(order) }}</span>
                        </div>
                      </div>

                      <!-- NO, BUT NOT POSSIBLE! NO FILES! (sent to print?) -->
                      <div *ngIf="
                          !isEmptyFixProductsPaymentOrder(order) &&
                          !isOrderAddedToQueue(order) &&
                          (order.status === 'PENDING' ||
                            order.status === 'QR' ||
                            order.status === 'NOT_PAID') &&
                          !(!order.files || order.files.length > 0)
                        " class="d-flex flex-column zx-status-con-70-p">
                        <!-- [whatsup btn] -->
                        <div class="d-flex flex-column gap-1 align-items-center pb-3 px-2">
                          <b class="text-red zx-text-tiny-tiny zx-text-sm-tiny" [class.zx-text-white]="isDarkMode">
                            {{
                            "my-orders.contact-us-no-files-order" | translate
                            }}
                          </b>
                          <button mat-raised-button (click)="openWhatsApp()"
                            class="rounded-pill zx-text-tiny zx-text-sm-small">
                            <div class="w-100 h-100 d-flex align-items-center gap-2">
                              <div class="whatsup-logo-container-small">
                                <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo"
                                  class="whatsup-logo-small" />
                              </div>
                              <span class="zx-text-tiny-tiny">
                                {{ "main-nav.contact-us" | translate }}
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>

                      <!-- IN_QUOTATION – יש הצעת מחיר ולא בוטלה: תא (2/3) + כפתור צפה בהצעה (1/3) -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'IN_QUOTATION' && order.files && order.files.length > 0 && !order.isDeleted && getLastPriceQuoteForOrder(order) && !getLastPriceQuoteForOrder(order)?.isCancelled">
                        <div class="d-flex justify-content-center zx-status-con-33-p align-items-stretch" [class.text-end]="isRTL" [class.text-start]="!isRTL">
                          <div class="d-flex flex-column justify-content-center" style="min-width: 0;">
                            <b class="zx-text-tiny zx-text-sm-small text-green">
                              {{ "my-orders.status.IN_QUOTATION" | translate }}
                            </b>
                            <div *ngIf="getLastPriceQuoteForOrder(order)?.createdAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-column flex-shrink-0 zx-status-con-33-p px-2 justify-content-center">
                          <button mat-raised-button color="primary" class="print-button rounded-pill d-flex align-items-center justify-content-center w-100"
                            (click)="navigateToChat(order)">
                            <span class="zx-text-sm-small text-white d-none d-sm-inline">{{ "my-orders.view-offer" | translate }}</span>
                            <span class="zx-text-sm-small text-white d-inline d-sm-none">{{ "my-orders.view-offer-short" | translate }}</span>
                          </button>
                        </div>
                      </ng-container>
                      <!-- IN_QUOTATION – בוטלה: שלושה אלמנטים נפרדים (תא, חץ, תא) כמו בשאר ציר הזמן -->
                      <ng-container *ngIf="isPHOrder(order) && order.status === 'IN_QUOTATION' && order.files && order.files.length > 0 && !order.isDeleted && getLastPriceQuoteForOrder(order)?.isCancelled">
                        <div class="d-flex justify-content-center zx-status-con-33-p">
                          <div class="d-flex flex-column">
                            <b class="zx-text-tiny zx-text-sm-small text-green">{{ "my-orders.status.IN_QUOTATION" | translate }}</b>
                            <div *ngIf="getLastPriceQuoteForOrder(order)?.createdAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.createdAt | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>
                        <div class="d-flex justify-content-center zx-status-con-33-p">
                          <div class="d-flex flex-column">
                            <b class="zx-text-tiny zx-text-sm-small text-red">{{ "chat.price-quote-cancelled" | translate }}</b>
                            <div *ngIf="getLastPriceQuoteForOrder(order)?.cancelledAt" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.cancelledAt | date : "dd/MM/yy" }}</span>
                              <span class="zx-text-tiny">{{ getLastPriceQuoteForOrder(order)?.cancelledAt | date : "HH:mm" }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- YES (sent to print?) – לא לפלוטר/אקספרס REFUNDED/REFUNDED_POINTS (יש להם ציר זמן ייעודי); לא לבקשת תשלום ריקה -->
                      <div *ngIf="isOrderAddedToQueue(order) && !isPHOrder(order) && order.status !== 'REFUNDED' && order.status !== 'REFUNDED_POINTS' && !isEmptyFixProductsPaymentOrder(order)"
                        class="d-flex justify-content-center zx-status-con-30-p">
                        <div class="d-flex flex-column">
                          <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">
                            {{ "my-orders.added-to-queue" | translate }}
                          </b>
                          <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                            <span class="zx-text-tiny">
                              {{ isOrderAddedToQueue(order) | date : "dd/MM/yy" }}
                            </span>
                            <span class="zx-text-tiny">
                              {{ isOrderAddedToQueue(order) | date : "HH:mm" }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- // YES (sent to print?) -->

                      <!-- NO, PH ORDER - NOT PRINTED -->
                      <div *ngIf="isPHOrder(order) && order.status === 'PAID' &&
                      order.files && order.files.length > 0 && !order.isDeleted
                        " class="d-flex flex-column flex-shrink-0 zx-status-con-70-p px-3 gap-1 gap-lg-2">
                        <!-- [times] – pickup: בלי "מ" במחר/מחרתיים; points/delivery: מבנה קיים -->
                        <span class="zx-text-tiny opacity-50 text-sm-center">{{ getCommitmentTimeText(order) }}</span>

                      </div>
                      <!-- // NO, PH ORDER - NOT PRINTED -->

                      <!-- >>> -->
                      <div *ngIf="
                          isOrderAddedToQueue(order) &&
                          (order.status === 'DONE' ||
                            order.status === 'REFUNDED' ||
                            order.status === 'REFUNDED_POINTS' ||
                            order.status === 'CANCELLED') &&
                          !isPhOrderCancelled(order) &&
                          !(isPHOrder(order) && order.status === 'REFUNDED') &&
                          !(!isPHOrder(order) && (order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS') && isOrderAddedToQueue(order)) &&
                          !isEmptyFixProductsPaymentOrder(order)
                        " class="zx-seperation-arrow zx-status-con-10-p" [class.mirror]="!isRTL" role="img" aria-hidden="true"></div>

                      <!-- printed? -->
                      <!-- NO, AND NOT POSSIBLE! (EXPIRED or REFUNDED) (printed?) – לא להזמנת PH REFUNDED ולא פלוטר/אקספרס שהודפסו וזוכו (יש להם ציר זמן ייעודי) -->
                      <div *ngIf="
                          (order.status === 'EXPIRED' ||
                          order.status === 'REFUNDED' ||
                          order.status === 'REFUNDED_POINTS' ||
                          order.status === 'CANCELLED' ||
                          order.isDeleted) &&
                          !isPhOrderCancelled(order) &&
                          !(isPHOrder(order) && order.status === 'REFUNDED') &&
                          !(!isPHOrder(order) && (order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS') && isOrderAddedToQueue(order))
                        " class="d-flex flex-column zx-status-con-30-p"
                        [class.zx-status-con-70-p]="!isOrderAddedToQueue(order)">
                        <!-- EXPIRED -->
                        <div *ngIf="order.status === 'EXPIRED' && !order.isDeleted && !isEmptyFixProductsPaymentOrder(order)"
                          class="d-flex flex-column align-items-center justify-content-center gap-1">
                          <b class="zx-text-tiny zx-text-sm-small text-red text-center"
                            [class.zx-text-white]="isDarkMode">
                            {{ "my-orders.order-expired" | translate }}
                          </b>
                          <span class="zx-text-tiny-tiny text-red text-center" [class.zx-text-white]="isDarkMode">
                            {{ "my-orders.order-expired-explain" | translate }}
                          </span>
                        </div>
                        <!-- REFUNDED | REFUNDED_POINTS | CANCELLED | isDeleted -->
                        <div *ngIf="
                            order.status === 'REFUNDED' ||
                            order.status === 'REFUNDED_POINTS' ||
                            order.status === 'CANCELLED' ||
                            order.isDeleted
                          " class="d-flex flex-column align-items-center justify-content-center">
                          <b class="zx-text-tiny zx-text-sm-small text-green text-center">
                            <span *ngIf="isPHOrder(order) && order.status === 'REFUNDED'">{{ "my-orders.ph-timeline.credited" | translate }}</span>
                            <span *ngIf="!(isPHOrder(order) && order.status === 'REFUNDED')">{{ "my-orders.order-refunded" | translate }}</span>
                          </b>
                          <span class="zx-text-tiny-tiny text-green text-center">
                            <span *ngIf="order.status === 'REFUNDED_POINTS'">
                              {{
                              "my-orders.order-refunded-explain.points"
                              | translate
                              }}
                            </span>
                            <span *ngIf="order.status === 'CANCELLED'">
                              {{
                              "my-orders.order-refunded-explain.no-refund"
                              | translate
                              }}
                            </span>
                          </span>
                          <div *ngIf="order.creditedAt && (order.status === 'REFUNDED' || order.status === 'REFUNDED_POINTS')" class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50 justify-content-center">
                            <span class="zx-text-tiny">{{ order.creditedAt | date : "dd/MM/yy" }}</span>
                            <span class="zx-text-tiny">{{ order.creditedAt | date : "HH:mm" }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- YES (printed?) – לא לבקשת תשלום ריקה -->
                      <div *ngIf="isOrderAddedToQueue(order) && order.status === 'DONE' && !isEmptyFixProductsPaymentOrder(order)"
                        class="d-flex justify-content-center zx-status-con-30-p">
                        <div class="d-flex flex-column">
                          <b class="zx-text-tiny zx-text-sm-small" [class.text-green]="!order.resentData?.originalOrderId" [class.zx-text-pink]="order.resentData?.originalOrderId">
                            {{ "my-orders.printed" | translate }}
                          </b>
                          <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                            <!-- [plotter] -->
                            <span *ngIf="!order.branchID?.is_express" class="zx-text-tiny">
                              {{ order.print_end | date : "dd/MM/yy" }}
                            </span>
                            <!-- [express] -->
                            <span *ngIf="order.branchID?.is_express" class="zx-text-tiny">
                              {{ isOrderAddedToQueue(order) | date : "dd/MM/yy" }}
                            </span>
                            <!-- [plotter] -->
                            <span *ngIf="!order.branchID?.is_express" class="zx-text-tiny">
                              {{ order.print_end | date : "HH:mm" }}
                            </span>
                            <!-- [express] -->
                            <span *ngIf="order.branchID?.is_express" class="zx-text-tiny">
                              {{
                              addSecondsToDate(
                              isOrderAddedToQueue(order),
                              order.files.length
                              ) | date : "HH:mm"
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- // YES (printed?) -->

                      <!-- YES (fix products only) -->
                      <div *ngIf="order.is_only_fix_products_in_order && !isEmptyFixProductsPaymentOrder(order)"
                        class="d-flex justify-content-center zx-status-con-70-p">
                        <div class="d-flex flex-column">
                          <b class="zx-text-tiny zx-text-sm-small text-green">
                            {{
                            "fix-products.only-fix-products-order" | translate
                            }}
                          </b>
                        </div>
                      </div>
                      <!-- // YES (sent to print?) -->
                    </div>
                  </div>
                  <!-- // status and times -->
                </div>

                <!-- ERROR row -->
                <!-- NOT ALL IMAGES HAVE PAPER [whatsup btn] -->
                <div *ngIf="!isAllFilesHavePaperSet(order)" class="d-flex w-100 py-1 px-2">
                  <div class="d-flex flex-column gap-1 align-items-center">
                    <b class="text-red zx-text-tiny-tiny zx-text-sm-tiny" [class.zx-text-white]="isDarkMode">
                      {{ "my-orders.contact-us-no-paper-on-order" | translate }}
                    </b>
                    <button mat-raised-button (click)="openWhatsApp()"
                      class="rounded-pill zx-text-tiny zx-text-sm-small px-3">
                      <div class="w-100 h-100 d-flex align-items-center gap-2">
                        <div class="whatsup-logo-container-small">
                          <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small" />
                        </div>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny whatsup-logo-text">
                          {{ "main-nav.contact-us" | translate }}
                        </span>
                      </div>
                    </button>
                  </div>
                </div>
              </article>
            </article>
          </article>
        </mat-expansion-panel-header>
        <!-- // order header -->

        <!-- SENT order content – לא לבקשת תשלום ממתינה (אין קבצים / אין מה להרחיב) -->
        <div *ngIf="!isEmptyFixProductsPaymentOrder(order)" class="d-flex flex-column w-100 flex-grow-1">
          <div class="zx-bg-order px-4 pb-2">
            <span class="zx-text-small text-green">
              <span>{{ "my-orders.order-num" | translate }}</span>
              <span class="zx-100-opp">-</span>
              <span>{{ order._id.slice(0, 8) }}</span>
              <span>:</span>
            </span>
          </div>

          <!-- files [plotter] ---------- files [plotter] ---------- files [plotter]  -->
          <div *ngIf="
              order.branchID &&
              !order.branchID?.is_express &&
              order.files &&
              order.files.length > 0
            " class="d-flex flex-grow-1 w-100 position-relative">
            <div
              class="d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-order rounded-2"
              [class.zx-choosen-order-action]="
                (order.status !== 'PENDING' &&
                  order.status !== 'QR' &&
                  order.status !== 'NOT_PAID') ||
                order.isDeleted
              " [class.zx-border-gray-25-pr]="isDarkMode">
              <section *ngIf="isManagementView && hasResentTimes(order)"
                class="d-flex w-100 p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 align-items-start flex-column gap-2"
                [class.zx-bg-dark-no-border]="isDarkMode">
                <span class="zx-text-small text-green">{{ "my-orders.resent" | translate }}</span>
                <div class="row w-100 m-0">
                  <div *ngFor="let resentTime of getResentTimes(order)" class="col-6 col-md-3 p-1">
                    <div class="d-flex align-items-center justify-content-center gap-1 px-2 px-sm-3 py-1 rounded-pill zx-bg-gray"
                      [class.zx-border-gray-25-pr]="isDarkMode">
                      <span class="zx-text-tiny text-green text-center">{{ resentTime | date : "dd/MM/yy" }}</span>
                      <span class="zx-text-tiny text-center">{{ resentTime | date : "HH:mm" }}</span>
                    </div>
                  </div>
                </div>
              </section>
              <!-- ===== files ===== -->
              <section
                ngClass="d-flex w-100 row p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 gap-2 gap-md-0"
                [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                *ngFor="let file of order.files; index as i; trackBy: trackByOrderFileRow" class="d-flex w-100">
                <!-- name - multi page -->
                <span *ngIf="file.images.length > 1" class="zx-text-small zx-text-pink col-12 w-100 p-0 pb-lg-2 px-lg-2"
                  [class.text-start]="!isRTL" [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode"
                  [class.zx-ltr]="!isRTL">
                  <span class="d-sm-none">
                    <span>
                      {{ getDisplayFileNameAfterSplit(file) | slice : 0 : 17 }}
                    </span>
                    <span *ngIf="getDisplayFileNameAfterSplit(file).length > 17">
                      ...
                    </span>
                    <span class="zx-100-opacity">--</span>
                    <span class="fw-normal zx-text-tiny text-green">
                      <span>(</span>
                      <span>
                        {{ file.images.length }}
                      </span>
                      <span class="zx-text-tiny-tiny">
                        {{ "printing-table.pages-short" | translate }}
                      </span>
                      <span>)</span>
                    </span>
                  </span>
                  <span class="d-none d-sm-flex">
                    <span>
                      {{ getDisplayFileNameAfterSplit(file) | slice : 0 : 40 }}
                    </span>
                    <span *ngIf="getDisplayFileNameAfterSplit(file).length > 40">
                      ...
                    </span>
                    <span class="zx-100-opacity">--</span>
                    <span class="fw-normal text-green">
                      <span>(</span>
                      <span>
                        {{ file.images.length }}
                      </span>
                      <span class="zx-text-tiny">
                        {{ "printing-table.pages-short" | translate }}
                      </span>
                      <span>)</span>
                    </span>
                  </span>
                </span>
                <!-- 1st line -->
                <article *ngFor="let image of file.images; index as j; trackBy: trackByImageInFile"
                  class="d-flex align-items-center gap-2 gap-lg-3 p-0 position-relative"
                  [class.zx-border-gray-top-25-pr]="file.images.length > 1" [class.zx-border-gray-left-25-pr-md]="
                    j % 2 === 0 && file.images.length > 1
                  " [class.flex-row-reverse]="!isRTL" [class.col-12]="file.images.length === 1"
                  [class.py-1]="file.images.length > 1" [class.py-lg-2]="file.images.length > 1"
                  [class.ps-md-2]="file.images.length > 1 && j % 2 === 0"
                  [class.pe-md-2]="file.images.length > 1 && j % 2 !== 0" [class.col-12]="file.images.length > 1"
                  [class.col-md-6]="file.images.length > 1">
                  <!-- image -->
                  <article
                    class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                    <!-- -----===----- thumbnail 1/1 [plotter] -----===----- -->
                    <div class="d-flex zx-medium-plus-icon-size rounded-1">
                      <!-- thumbnail 1/1 [plotter] -->
                      <img (click)="
                          openPreviewDialogInner('plotter', order, file, j)
                        " *ngIf="!plotterImageErrors[o][i][j]" (error)="plotterImageErrors[o][i][j] = true"
                        class="w-100 h-100 object-fit-contain c-pointer" [src]="getImgPlotter(order, i, j)"
                        [matTooltip]="'printing-table.preview' | translate" [matTooltipPosition]="'above'" />
                      <!-- error finding image src? -->
                      <div *ngIf="plotterImageErrors[o][i][j]" class="d-flex flex-column align-items-center" matTooltip="{{
                          'my-orders.no-img-src-explain' | translate
                        }}" matTooltipPosition="below" matTooltipClass="centered-tooltip">
                        <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg" />
                        <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                          [class.zx-text-white]="isDarkMode">
                          {{ "my-orders.no-img-src" | translate }}
                        </b>
                      </div>
                      <!-- // error finding image src? -->
                    </div>
                    <!-- -----===----- // thumbnail 1/1 [plotter] -----===----- -->

                    <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                      <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                        <span>{{
                          roundDownTowDecimal(image.imageHeight * (2.54 / 300))
                          }}</span>
                        <span> × </span>
                        <span>{{
                          roundDownTowDecimal(image.imageWidth * (2.54 / 300))
                          }}</span>
                        <span class="zx-text-tiny-tiny">
                          {{ "printing-table.dimensions-cm" | translate }}
                        </span>
                      </span>
                    </div>
                    <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0">
                      <span class="p-1 p-lg-2 zx-bg-light">
                        <div class="d-flex align-items-center text-green zx-text-tiny" [class.flex-row-reverse]="isRTL">
                          <span>
                            {{ j + 1 }}
                          </span>
                          <span>/</span>
                          <span>
                            {{ file.images.length }}
                          </span>
                        </div>
                      </span>
                    </article>
                    <!-- sentToPrinter or error? [plotter] -->
                    <div class="d-flex top-0 w-100 position-absolute"
                      [class.justify-content-end]="isRTL"
                      [class.justify-content-start]="!isRTL"
                      *ngIf="isOrderAddedToQueue(order) && isManagementView">
                      <mat-icon *ngIf="image.sentToPrinter"
                        class="zx-text-small text-green zx-text-sm-medium text-center pt-1" [matTooltip]="
                          'su-management.received-in-printer' | translate
                        " matTooltipPosition="above">check</mat-icon>
                      <mat-icon *ngIf="!image.sentToPrinter && !image.errorInSend"
                        class="zx-text-small text-orange zx-text-sm-medium text-center pt-1" [matTooltip]="
                          'su-management.no-received-in-printer-yet' | translate
                        " matTooltipPosition="above">error_outline</mat-icon>
                      <mat-icon *ngIf="!image.sentToPrinter && image.errorInSend"
                        class="zx-text-small text-red zx-text-sm-medium text-center pt-1" [matTooltip]="
                          'su-management.rejected-by-printer' | translate
                        " matTooltipPosition="above">error</mat-icon>
                    </div>
                  </article>

                  <!-- file date -->
                  <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">
                    <!-- [up container] - for more then 1 copy in 1 image files -->
                    <div class="d-flex d-sm-none w-100" *ngIf="
                        file.images.length === 1 &&
                        image.printSettings.numOfCopies > 1
                      " [class.flex-row-reverse]="!isRTL">
                      <!-- name - single page -->
                      <span class="zx-text-small zx-text-pink" [class.zx-ltr]="!isRTL" [class.fw-bold]="!isDarkMode"
                        [class.zx-text-white]="isDarkMode">
                        <span class="d-sm-none" [class.zx-ltr]="!isRTL">
                          <span>
                            {{ getDisplayFileNameAfterSplit(file) | slice : 0 : 12 }}
                          </span>
                          <span *ngIf="getDisplayFileNameAfterSplit(file).length > 12">
                            ...
                          </span>
                        </span>
                        <span class="d-none d-sm-flex" [class.zx-ltr]="!isRTL">
                          <span>
                            {{ getDisplayFileNameAfterSplit(file) | slice : 0 : 30 }}
                          </span>
                          <span *ngIf="getDisplayFileNameAfterSplit(file).length > 30">
                            ...
                          </span>
                        </span>
                      </span>
                    </div>

                    <!-- [up container] -->
                    <div class="d-flex w-100 justify-content-between align-items-center"
                      [class.pb-1]="file.images.length === 1" [class.flex-row-reverse]="!isRTL">
                      <!-- name placeholder - milti page -->
                      <span *ngIf="file.images.length > 1" class="zx-100-opacity">-</span>
                      <!-- name - single page -->
                      <span *ngIf="file.images.length === 1" class="zx-text-small zx-text-pink" [class.zx-ltr]="!isRTL"
                        [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode">
                        <span *ngIf="image.printSettings.numOfCopies === 1" class="d-sm-none" [class.zx-ltr]="!isRTL">
                          <span>
                            {{ getDisplayFileNameAfterSplit(file) | slice : 0 : 12 }}
                          </span>
                          <span *ngIf="getDisplayFileNameAfterSplit(file).length > 12">
                            ...
                          </span>
                        </span>
                        <span class="d-none d-sm-flex" [class.zx-ltr]="!isRTL">
                          <span>
                            {{ getDisplayFileNameAfterSplit(file) | slice : 0 : 30 }}
                          </span>
                          <span *ngIf="getDisplayFileNameAfterSplit(file).length > 30">
                            ...
                          </span>
                        </span>
                      </span>
                      <!-- total file price -->
                      <span *ngIf="image.price && image.price > 0" class="px-1 px-lg-3" [class.zx-ltr]="!isRTL"
                        [class.zx-text-white]="isDarkMode">
                        <span *ngIf="image.printSettings.numOfCopies > 1" class="zx-text-tiny fw-normal"
                          [class.zx-ltr]="!isRTL">
                          <span>
                            {{ roundDownTowDecimal(image.price) }}
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ "printing-table.nis" | translate }}
                          </span>
                          <span>×</span>
                          <span>
                            {{ image.printSettings.numOfCopies }}
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ "printing-table.copies-short" | translate }}
                          </span>
                          <span>=</span>
                        </span>
                        <span class="zx-text-small">
                          {{
                          roundDownTowDecimal(
                          image.printSettings.numOfCopies * image.price
                          )
                          }}
                        </span>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                          {{ "printing-table.nis" | translate }}
                        </span>
                      </span>
                    </div>

                    <!-- [settings] -->
                    <div class="d-flex flex-column gap-1 gap-lg-2">
                      <!-- paper & bw & resize -->
                      <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <!-- paper -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <b *ngIf="
                              getPaperSerialName(
                                image.printSettings?.paperType,
                                order.printerID.inputBins
                              )
                            " class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            {{
                            "paper-type.name-short." +
                            getPaperSerialName(
                            image.printSettings.paperType,
                            order.printerID.inputBins
                            ) | translate
                            }}
                          </b>
                          <b *ngIf="
                              !getPaperSerialName(
                                image.printSettings?.paperType,
                                order.printerID.inputBins
                              )
                            " class="zx-text-tiny text-red" [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.image-no-paper" | translate }}
                          </b>
                        </div>
                        <!-- bw -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!image.printSettings.bw">
                              {{ "printing-table.color-color" | translate }}
                            </span>
                            <span *ngIf="image.printSettings.bw">
                              {{ "printing-table.color-bandw" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- resize -->
                        <div *ngIf="file.images.length === 1"
                          class="d-flex justify-content-center text-center px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny text-center" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                            <span *ngIf="image.scale > 1">
                              {{ "order-summary-resize-bigger" | translate }}
                            </span>
                            <span *ngIf="image.scale < 1">
                              {{ "order-summary-resize-smaller" | translate }}
                            </span>
                            <span *ngIf="image.scale === 1">
                              {{ "order-summary-resize-original" | translate }}
                            </span>
                            <span *ngIf="image.scale !== 1" [class.zx-ltr]="!isRTL">
                              <span *ngIf="isRTL">%</span>
                              <span>
                                {{ roundDownTowDecimal(image.scale * 100) }}
                              </span>
                              <span *ngIf="!isRTL">%</span>
                            </span>
                          </span>
                        </div>
                      </div>
                      <!-- center & borders & copies -->
                      <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <!-- center -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!image.printSettings.centered">
                              {{ "order-summary-not-centered" | translate }}
                            </span>
                            <span *ngIf="image.printSettings.centered">
                              {{ "order-summary-is-centered" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- borders -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!image.printSettings.cmFromTop">
                              {{ "order-summary-not-borders" | translate }}
                            </span>
                            <span *ngIf="image.printSettings.cmFromTop">
                              {{ "order-summary-is-borders" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- copies -->
                        <div *ngIf="image.printSettings.numOfCopies !== 1"
                          class="d-flex px-1 px-sm-2 my-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                            <span>{{ image.printSettings.numOfCopies }}</span>
                            <span>
                              {{ "printing-table.copies-short" | translate }}
                            </span>
                          </span>
                        </div>
                      </div>

                      <!-- resize & doanload -->
                      <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <div *ngIf="file.images.length > 1" class="d-flex justify-content-center text-center px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny text-center" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                            <span *ngIf="image.scale > 1">
                              {{ "order-summary-resize-bigger" | translate }}
                            </span>
                            <span *ngIf="image.scale < 1">
                              {{ "order-summary-resize-smaller" | translate }}
                            </span>
                            <span *ngIf="image.scale === 1">
                              {{ "order-summary-resize-original" | translate }}
                            </span>
                            <span *ngIf="image.scale !== 1" [class.zx-ltr]="!isRTL">
                              <span *ngIf="isRTL">%</span>
                              <span>
                                {{ roundDownTowDecimal(image.scale * 100) }}
                              </span>
                              <span *ngIf="!isRTL">%</span>
                            </span>
                          </span>
                        </div>
                        <span *ngIf="isManagementView" class="d-flex flex-grow-1"></span>

                        <!-- ----- download file [plotter]----- -->
                        <div *ngIf="isManagementView" [matMenuTriggerFor]="downloadFileManu"
                          class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-green-border-gray c-pointer"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">
                            {{ "su-management.users.download" | translate }}
                          </span>
                        </div>
                        <mat-menu #downloadFileManu="matMenu">
                          <!-- download ORIGINAL -->
                          <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                            (click)="onDownloadOriginalFile('plotter', j, file, order, true)">
                            <b class="zx-text-small m-0">
                              {{'su-management.users.download-original' | translate}}
                            </b>
                            <mat-icon class="mx-1 p-0 zx-pt-small">crop_original</mat-icon>
                          </button>
                          <!-- download PRINTED -->
                          <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                            [disabled]="order.status === 'PENDING'"
                            (click)="onDownloadOriginalFile('plotter', j, file, order, false)">
                            <b class="zx-text-small m-0">
                              {{'su-management.users.download-printed' | translate}}
                            </b>
                            <mat-icon class="mx-1 p-0 zx-pt-small">file_copy</mat-icon>
                          </button>
                        </mat-menu>
                        <!-- // ----- download file [plotter]----- -->

                      </div>
                    </div>
                  </article>
                  <!-- // file date -->
                  <button *ngIf="canShareOrderPage(order) && !plotterImageErrors[o][i][j]"
                    type="button"
                    class="my-orders-share-wall-btn"
                    [class.my-orders-share-wall-btn--pair-inset]="file.images.length > 1 && j % 2 === 0"
                    [matTooltip]="'order-complited.wall.subtitle' | translate"
                    matTooltipPosition="above"
                    [matTooltipDisabled]="!isShareWallTooltipDesktop()"
                    (click)="shareOrderPageToWall(order, file, image, j, $event, i)">
                    {{ 'my-orders.share-to-wall' | translate }}
                  </button>
                </article>
                <!-- // 1st line -->
              </section>
              <!-- // ===== files ===== -->
            </div>
          </div>
          <!-- // files [plotter] ---------- files [plotter] ---------- files [plotter]  -->

          <!-- files [express/ph] ---------- files [express/ph] ---------- files [express]  -->
          <div *ngIf="(order.branchID && order.branchID?.is_express) || isPHOrder(order)"
            class="d-flex flex-grow-1 w-100 position-relative">
            <div
              class="d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-order rounded-2"
              [class.zx-choosen-order-action]="
                (order.status !== 'PENDING' &&
                  order.status !== 'QR' &&
                  order.status !== 'NOT_PAID') ||
                order.isDeleted
              " [class.zx-border-gray-25-pr]="isDarkMode">

              <!-- PH - PLACE DETAILS (כמו בצ'אט: דסקטופ – שורה אחת צמוד לקצות; מובייל – מחיר בשורה נפרדת צמוד לסוף) -->
              <section *ngIf="isPHOrder(order)"
                class="d-flex w-100 p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 flex-column flex-sm-row align-items-sm-center justify-content-sm-between gap-2"
                [class.zx-bg-dark-no-border]="isDarkMode">
                <div class="d-flex align-items-center gap-2 min-w-0">
                  <img [alt]="'pickup icon'" class="zx-small-plus-icon-size mx-2"
                    [src]="'assets/images/' + order.collectionData?.selectedCollectOption + '-icon.svg'" />
                  <span class="text-green">
                    <span>
                      {{ "collect." + order.collectionData?.selectedCollectOption + ".title" | translate }}
                    </span>
                    <span> - </span>
                    <span *ngIf="order.collectionData?.selectedCollectOption !== 'delivery'">
                      {{ getPlaceDisplayName(order.selectedPlace || order.collectionData?.selectedPlace) }}
                    </span>
                    <span>
                      {{ "collect.in-adress" | translate }}
                    </span>
                    <span>{{ getCollectionAddressDisplay(order) }}.</span>
                  </span>
                </div>
                <span class="zx-text-small opacity-75 flex-shrink-0 align-self-end align-self-sm-auto px-2" [class.zx-text-white]="isDarkMode">
                  <ng-container *ngIf="getCollectionPriceModifiedDisplay(order) as parts"><span class="strikethrough">{{ parts.original }}</span> {{ parts.modified }}</ng-container>
                  <ng-container *ngIf="!getCollectionPriceModifiedDisplay(order)">{{ getCollectionPriceDisplay(order) }}</ng-container>
                </span>
              </section>
              <!-- PH - TIME DETAILS -->
              <section *ngIf="hasPHOrderCommitmentToShow(order)"
                class="d-flex w-100 p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 align-items-start flex-column gap-2"
                [class.zx-bg-dark-no-border]="isDarkMode">
                <div *ngIf="isPriceQuoteCommitmentChanged(order)" class="w-100">
                  <span class="zx-text-small fw-bold zx-text-pink">{{ "chat.delivery-time-changed" | translate }}</span>
                </div>
                <div class="d-flex align-items-center gap-2 w-100">
                  <img [alt]="'clock icon'" class="zx-small-plus-icon-size mx-2"
                    [src]="'assets/images/clock-icon.svg'" />
                  <span class="text-green">{{ getCommitmentTimeText(order) }}</span>
                </div>
              </section>

              <section *ngIf="isManagementView && !isPHOrder(order) && hasResentTimes(order)"
                class="d-flex w-100 p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 align-items-start flex-column gap-2"
                [class.zx-bg-dark-no-border]="isDarkMode">
                <span class="zx-text-small text-green">{{ "my-orders.resent" | translate }}</span>
                <div class="row w-100 m-0">
                  <div *ngFor="let resentTime of getResentTimes(order)" class="col-6 col-md-3 p-1">
                    <div class="d-flex align-items-center justify-content-center gap-1 px-2 px-sm-3 py-1 rounded-pill zx-bg-gray"
                      [class.zx-border-gray-25-pr]="isDarkMode">
                      <span class="zx-text-tiny text-green text-center">{{ resentTime | date : "dd/MM/yy" }}</span>
                      <span class="zx-text-tiny text-center">{{ resentTime | date : "HH:mm" }}</span>
                    </div>
                  </div>
                </div>
              </section>

              <!-- ===== files ===== -->
              <section
                class="d-flex w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 align-items-start my-orders-express-file-card"
                [class.zx-bg-dark-no-border]="isDarkMode" *ngFor="let file of (order.expressFilesUi || order.files); index as i; trackBy: trackByOrderFileRow">
                <ng-template #expressChunkPartDownload let-partFile="partFile" let-orderCtx="orderCtx">
                  <div class="w-100 d-flex justify-content-center">
                    <div [matMenuTriggerFor]="chunkPartDownloadMenu"
                      class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill text-center zx-bg-green-border-gray c-pointer"
                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                      <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">
                        {{ "su-management.users.download" | translate }}
                      </span>
                    </div>
                    <mat-menu #chunkPartDownloadMenu="matMenu">
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                        (click)="onDownloadOriginalFile('express', 0, partFile, orderCtx, true)">
                        <b class="zx-text-small m-0">{{ 'su-management.users.download-original' | translate }}</b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">crop_original</mat-icon>
                      </button>
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                        (click)="onDownloadOriginalFile('express', 0, partFile, orderCtx, 'processedNotSent')">
                        <b class="zx-text-small m-0">{{ 'su-management.users.download-processed-not-sent' | translate }}</b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">edit_note</mat-icon>
                      </button>
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                        [disabled]="orderCtx.status === 'PENDING'"
                        (click)="onDownloadOriginalFile('express', 0, partFile, orderCtx, false)">
                        <b class="zx-text-small m-0">{{ 'su-management.users.download-printed' | translate }}</b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">file_copy</mat-icon>
                      </button>
                    </mat-menu>
                  </div>
                </ng-template>
                <!-- 1st line -->
                <article class="d-flex align-items-center gap-2 gap-lg-3 w-100 position-relative" [class.flex-row-reverse]="!isRTL">
                  <!-- first image -->
                  <article
                    class="zx-order-summery-image-con d-flex flex-column align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light"
                    [class.justify-content-center]="is3DOrder(order)"
                    [class.justify-content-between]="!is3DOrder(order)">
                    <!-- -----===----- thumbnail 1/2 [express] -----===----- -->
                    <ng-container *ngIf="getExpressFileFirstDisplayItem(file) as firstItem">
                    <ng-container *ngIf="firstItem.type === 'partHeader' && isManagementView">
                      <b class="zx-text-tiny text-green text-center pt-1">
                        {{ getExpressChunkPartLabel(firstItem.partNumber) }}
                      </b>
                      <div class="w-100 d-flex justify-content-center pb-1">
                        <ng-container *ngTemplateOutlet="expressChunkPartDownload; context: { partFile: firstItem.sourceFile, orderCtx: order }"></ng-container>
                      </div>
                    </ng-container>
                    <div *ngIf="firstItem.type === 'image'" class="d-flex zx-medium-plus-icon-size rounded-1">
                      <img *ngIf="!expressImageErrors1[o][firstItem.sourceFileIndex][firstItem.sourcePageIndex]"
                        (error)="expressImageErrors1[o][firstItem.sourceFileIndex][firstItem.sourcePageIndex] = true"
                        (click)="!is3DOrder(order) && openPreviewDialogInner('express', order, firstItem.sourceFile, firstItem.sourcePageIndex, firstItem.sourceFile)"
                        class="w-100 h-100 object-fit-contain" [class.c-pointer]="!is3DOrder(order)"
                        [matTooltip]="is3DOrder(order) ? '' : ('printing-table.preview' | translate)"
                        [matTooltipPosition]="'above'"
                        [src]="getImgExpress(order, firstItem.image)" alt="File Page Image" />
                      <div *ngIf="expressImageErrors1[o][firstItem.sourceFileIndex][firstItem.sourcePageIndex]" class="d-flex flex-column align-items-center"
                        matTooltip="{{
                          'my-orders.no-img-src-explain' | translate
                        }}" matTooltipPosition="below" matTooltipClass="centered-tooltip">
                        <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg" />
                        <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                          [class.zx-text-white]="isDarkMode">
                          {{ "my-orders.no-img-src" | translate }}
                        </b>
                      </div>
                    </div>
                    </ng-container>
                    <!-- -----===----- // thumbnail 1/2 [express] -----===----- -->

                    <ng-container *ngIf="getExpressFileFirstDisplayItem(file) as dimItem">
                    <div *ngIf="!is3DOrder(order) && dimItem.type === 'image'" class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                      <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                        <span *ngIf="!isPHOrder(order)">{{ getExpressDimensions("h", dimItem.image.imageHeight, dimItem.image.imageWidth, file.printSettings, order.printerID?.consumables?.papers || [], dimItem.image.origImageDPI) }}</span>
                        <span *ngIf="isPHOrder(order)">{{ getPHDimensions("h", order, file, dimItem.image) }}</span>
                        <span>×</span>
                        <span *ngIf="!isPHOrder(order)">{{ getExpressDimensions("w", dimItem.image.imageHeight, dimItem.image.imageWidth, file.printSettings, order.printerID?.consumables?.papers || [], dimItem.image.origImageDPI) }}</span>
                        <span *ngIf="isPHOrder(order)">{{ getPHDimensions("w", order, file, dimItem.image) }}</span>
                        <span class="zx-text-tiny-tiny">{{ "printing-table.dimensions-cm" | translate }}</span>
                      </span>
                    </div>
                    </ng-container>
                    <article *ngIf="getExpressFileImageCount(file) > 1 && !file._splitExpressMerged && getExpressFileFirstDisplayItem(file)?.type === 'image'"
                      class="position-absolute d-flex w-100 top-0" [class.flex-row-reverse]="!isRTL">
                      <span class="p-1 p-lg-2 zx-bg-light">
                        <div class="d-flex align-items-center text-green zx-text-tiny" [class.flex-row-reverse]="isRTL">
                          <span>1</span>
                          <span>/</span>
                          <span>{{ getExpressFileImageCount(file) }}</span>
                        </div>
                      </span>
                    </article>
                    <ng-container *ngIf="getExpressFileFirstDisplayItem(file) as statusItem">
                    <ng-container *ngIf="shouldShowExpressPrinterStatus(order, file, file._isChunkedMerged ? statusItem : undefined)">
                    <ng-container *ngIf="getExpressPrinterStatusFile(file, file._isChunkedMerged ? statusItem : undefined) as statusFile">
                    <div class="d-flex top-0 w-100 position-absolute"
                      [class.justify-content-end]="isRTL"
                      [class.justify-content-start]="!isRTL"
                      *ngIf="isManagementView">
                      <mat-icon *ngIf="!statusFile.error && (statusFile.sentToPrinter || statusFile.remote_id)"
                        class="zx-text-small text-green zx-text-sm-medium text-center pt-1"
                        [matTooltip]="'su-management.received-in-printer' | translate" matTooltipPosition="above">check</mat-icon>
                      <mat-icon *ngIf="!statusFile.error && !(statusFile.sentToPrinter || statusFile.remote_id)"
                        class="zx-text-small text-orange zx-text-sm-medium text-center pt-1"
                        [matTooltip]="'su-management.no-received-in-printer-yet' | translate" matTooltipPosition="above">error_outline</mat-icon>
                      <mat-icon *ngIf="statusFile.error" class="zx-text-small text-red zx-text-sm-medium text-center pt-1"
                        [matTooltip]="'su-management.rejected-by-printer' | translate" matTooltipPosition="above">error</mat-icon>
                    </div>
                    </ng-container>
                    </ng-container>
                    </ng-container>
                  </article>
                  <!-- file date -->
                  <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">
                    <!-- [up container] -->
                    <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                      [class.flex-row-reverse]="!isRTL">
                      <!-- name -->
                      <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                        [class.zx-text-white]="isDarkMode">
                        <span class="d-sm-none">
                          <span>
                            {{ (file._expressDisplayFileName || '') | slice : 0 : 17 }}
                          </span>
                          <span *ngIf="(file._expressDisplayFileName || '').length > 17">
                            ...
                          </span>
                        </span>
                        <span class="d-none d-sm-flex">
                          <span>
                            {{ (file._expressDisplayFileName || '') | slice : 0 : 40 }}
                          </span>
                          <span *ngIf="(file._expressDisplayFileName || '').length > 40">
                            ...
                          </span>
                        </span>
                      </span>
                      <!-- total file price -->
                      <span *ngIf="!is3DOrder(order) && (file._expressDisplayRowPrice ?? 0) > 0" class="px-1 px-lg-3" [class.zx-text-white]="isDarkMode">
                        <span class="zx-text-small">
                          {{ file._expressDisplayRowPrice }}
                        </span>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                          {{ "printing-table.nis" | translate }}
                        </span>
                      </span>
                    </div>

                    <!-- [settings] -->
                    <div class="d-flex flex-column gap-1 gap-lg-2" [class.flex-sm-row]="isRTL"
                      [class.flex-sm-row-reverse]="!isRTL">

                      <!-- 3D PH - material + color + fill + copies + post-production -->
                      <ng-container *ngIf="is3DOrder(order)">
                        <div class="d-flex flex-column w-100" style="flex-basis: 100%;">
                        <!-- הגדרות - שורה אחת בדסקטופ -->
                        <div class="d-flex flex-wrap flex-lg-nowrap gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                          <!-- material -->
                          <div *ngIf="file.printSettings?.material"
                            class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                            <b class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              {{ ('product-material.name.' + order.productID?.name + '-' + file.printSettings.material) | translate }}
                            </b>
                          </div>
                          <!-- color -->
                          <div *ngIf="file.printSettings?.color"
                            class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              {{ ('product-color.' + file.printSettings.color) | translate }}
                            </span>
                          </div>
                          <!-- fill -->
                          <div *ngIf="file.printSettings?.fill != null"
                            class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              {{ (file.printSettings.fill * 100 | number:'1.0-0') }}%
                            </span>
                          </div>
                          <!-- copies -->
                          <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                            [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <ng-container *ngIf="(file.printSettings?.numOfCopies || 1) === 1">{{ "printing-table.copy-one" | translate }}</ng-container>
                              <ng-container *ngIf="(file.printSettings?.numOfCopies || 1) !== 1">{{ file.printSettings?.numOfCopies || 1 }} {{ "printing-table.copies" | translate }}</ng-container>
                            </span>
                          </div>
                          <!-- post-production -->
                          <ng-container *ngIf="order.productID?.properties?.postProduction">
                            <ng-container *ngFor="let pp of order.productID.properties.postProduction">
                              <div *ngIf="pp.available && (file.printSettings?.postProduction || [])?.includes(pp.name)"
                                class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray text-center"
                                [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                  {{ ('product-post-production.' + pp.name) | translate }}
                                </span>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                        <!-- מידע נוסף למפעיל המכונה - תמיד בשורה נפרדת -->
                        <div *ngIf="file.printSettings?.estimatedLength != null || file.printSettings?.estimatedWidth != null || file.printSettings?.estimatedHeight != null || file.printSettings?.usage || file.printSettings?.additionalNotes"
                          class="d-flex flex-column gap-1 pt-2 mt-3 zx-border-top-gray-25-pr w-100" style="flex-basis: 100%;">
                          <span class="zx-text-tiny opacity-75" [class.zx-text-white]="isDarkMode">
                            {{ 'printing-table.additional-info-for-operator' | translate }}
                          </span>
                          <div class="d-flex flex-wrap gap-1 align-items-center zx-text-tiny" [attr.dir]="isRTL ? 'rtl' : 'ltr'" [class.zx-text-white]="isDarkMode">
                            <div class="d-flex flex-column flex-md-row gap-1 align-items-md-center" [attr.dir]="isRTL ? 'rtl' : 'ltr'">
                              <span *ngIf="file.printSettings?.estimatedLength != null || file.printSettings?.estimatedWidth != null || file.printSettings?.estimatedHeight != null">
                                {{ 'printing-table.estimated-dimensions' | translate }}: {{ file.printSettings?.estimatedLength ?? '-' }} × {{ file.printSettings?.estimatedWidth ?? '-' }} × {{ file.printSettings?.estimatedHeight ?? '-' }} {{ "printing-table.dimensions-cm" | translate }}
                              </span>
                              <span *ngIf="(file.printSettings?.estimatedLength != null || file.printSettings?.estimatedWidth != null || file.printSettings?.estimatedHeight != null) && file.printSettings?.usage" class="d-none d-md-inline"> | </span>
                              <span *ngIf="file.printSettings?.usage">
                                {{ 'printing-table.3dprint-usage' | translate }}: {{ (file.printSettings.usage === 'other' && file.printSettings.usageOther) ? file.printSettings.usageOther : ('printing-table.usage.' + file.printSettings.usage | translate) }}
                              </span>
                            </div>
                            <span *ngIf="file.printSettings?.additionalNotes" class="w-100">
                              {{ 'printing-table.additional-notes' | translate }}: {{ file.printSettings.additionalNotes }}
                            </span>
                          </div>
                        </div>
                        </div>
                      </ng-container>

                      <!-- 2D - paper & bw & copies -->
                      <ng-container *ngIf="!is3DOrder(order)">
                      <div class="d-flex flex-column w-100">
                      <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <!-- paper -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <b *ngIf="!isPHOrder(order) &&
                              getPaperSerialNameExpress(
                                file.printSettings.paperType,
                                order.printerID?.consumables?.papers || []
                              )
                            " class="zx-text-tiny zx-text-sm-small text-center" [class.zx-text-white]="isDarkMode">
                            {{
                            "paper-type.name-short." +
                            getPaperSerialNameExpress(
                            file.printSettings.paperType,
                            order.printerID?.consumables?.papers || []
                            ) | translate
                            }}
                          </b>
                          <b *ngIf="!isPHOrder(order) &&
                              !getPaperSerialNameExpress(
                                file.printSettings.paperType,
                                order.printerID?.consumables?.papers || []
                              )
                            " class="zx-text-tiny zx-text-sm-small text-red text-center"
                            [class.zx-text-white]="isDarkMode">
                            {{ "printing-table.image-no-paper" | translate }}
                          </b>
                          <b *ngIf="isPHOrder(order)" class="zx-text-tiny zx-text-sm-small text-center"
                            [class.zx-text-white]="isDarkMode">
                            {{ myOrdersPhPaperTypeNameKey(order.productID.name, file.printSettings.paperType) | translate }}
                          </b>
                        </div>
                        <!-- bw -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny zx-text-sm-small text-center" [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!file.printSettings.bw">
                              {{ "printing-table.color-color" | translate }}
                            </span>
                            <span *ngIf="file.printSettings.bw">
                              {{ "printing-table.color-bandw" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- copies -->
                        <div *ngIf="file.printSettings.numOfCopies !== 1"
                          class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny text-center" [class.zx-text-white]="isDarkMode">
                            <span>{{ file.printSettings.numOfCopies }}</span>
                            <span>
                              {{ "printing-table.copies-short" | translate }}
                            </span>
                          </span>
                        </div>
                      </div>

                      <!-- 2: doubleSided [express] + rotation [HP] [[[&]]] fit [express] + align [HP] -->
                      <div class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <!-- doubleSided [express] + rotation [HP]  -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <!-- doubleSided [express] -->
                          <span *ngIf="!isPHOrder(order)" class="zx-text-tiny zx-text-sm-small text-center"
                            [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!file.printSettings.doubleSided">
                              {{ "printing-table.sides-one" | translate }}
                            </span>
                            <span *ngIf="file.printSettings.doubleSided">
                              {{ "printing-table.sides-two" | translate }}
                            </span>
                          </span>
                          <!-- rotation [HP] -->
                          <span *ngIf="isPHOrder(order)" class="zx-text-tiny zx-text-sm-small text-center"
                            [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!file.printSettings.rotation || file.printSettings.rotation === 0">
                              {{ "printing-table.rotated-not" | translate }}
                            </span>
                            <span *ngIf="file.printSettings.rotation > 0">
                              <span>
                                {{ "printing-table.rotated" | translate }}
                              </span>
                              <span>
                                {{ file.printSettings.rotation }}°
                              </span>
                            </span>
                          </span>
                        </div>
                        <!-- fit [express] + align [HP]  -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <!-- fit [express] -->
                          <span *ngIf="!isPHOrder(order)" class="zx-text-tiny zx-text-sm-small text-center"
                            [class.zx-text-white]="isDarkMode">
                            <!-- Pics printer has only "כיסוי מלא" / "התאם לדף" – never show "מקורי" -->
                            <span *ngIf="
                                !order.printerID?.isPicsPrinter &&
                                !file.printSettings.fit &&
                                !file.printSettings.cropRatio
                              ">
                              {{ "order-summary-resize-original" | translate }}
                            </span>
                            <span *ngIf="
                                !file.printSettings.cropRatio &&
                                (file.printSettings.fit || order.printerID?.isPicsPrinter)
                              ">
                              {{ "order-summary-resize-maximal" | translate }}
                            </span>
                            <span *ngIf="file.printSettings.cropRatio">
                              {{ "order-summary-resize-crop" | translate }}
                            </span>
                          </span>
                          <!-- align [PH] -->
                          <span *ngIf="isPHOrder(order)" class="zx-text-tiny zx-text-sm-small text-center"
                            [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!file.printSettings.align || file.printSettings.align === 'center'">
                              {{ "order-summary-is-centered" | translate }}
                            </span>
                            <span *ngIf="!(!file.printSettings.align || file.printSettings.align === 'center')">
                              {{ "printing-table.align." + file.printSettings.align | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- isMerged: באקספרס (לא PH) מפוצל לשורות — בלי תג -->
                        <div *ngIf="file.isMerged && isManagementView && !isExpressMergedSplitContext(order)"
                          class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny zx-text-sm-small zx-text-pink text-center"
                            [class.zx-text-white]="isDarkMode">
                            <span>
                              {{ "my-orders.merged-file" | translate }}
                            </span>
                          </span>
                        </div>
                      </div>

                      <!-- 3: HP roll: cmFromTop-->
                      <div *ngIf="isPHOrder(order) && order.productID?.type === 'roll'"
                        class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <!-- cmFromTop -->
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny zx-text-sm-small text-center" [class.zx-text-white]="isDarkMode">
                            <span *ngIf="!file.printSettings.cmFromTop">
                              {{ "order-summary-not-borders" | translate }}
                            </span>
                            <span *ngIf="file.printSettings.cmFromTop">
                              {{ "order-summary-is-borders" | translate }}
                            </span>
                          </span>
                        </div>
                      </div>

                      <!-- אקספרס 2D: מצב רוסטר (complexity.rasterized) — מצב מנהל בלבד; תמיד שורה נפרדת מתחת להגדרות -->
                      <div *ngIf="isManagementView && !isPHOrder(order)" class="w-100" [class.text-end]="!isRTL">
                        <span class="zx-text-tiny text-green">{{ getExpressFileRasterizedLabelKey(file) | translate }}</span>
                      </div>

                      </div>
                      </ng-container>

                    </div>

                    <!-- calc file price -->
                    <span *ngIf="
                        file.images?.length > 1 &&
                        file.printSettings?.numOfCopies > 1
                      " [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                      <div *ngIf="
                          file.images.length > 1 ||
                          file.printSettings?.numOfCopies > 1 ||
                          isManagementView
                        " class="d-flex gap-1 gap-lg-2 align-items-center" [class.flex-row-reverse]="!isRTL">
                        <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <!-- pages -->
                          <span *ngIf="file.images.length > 1">
                            <span class="zx-text-tiny zx-text-sm-small">
                              {{ file.images.length }}
                            </span>
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                              {{ "printing-table.pages-short" | translate }}
                            </span>
                          </span>
                          <!-- , -->
                          <span *ngIf="
                              file.images.length > 1 &&
                              file.printSettings?.numOfCopies > 1
                            ">
                            <!-- <span class="zx-100-opacity">_</span> -->
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">,</span>
                            <span class="zx-100-opp">.</span>
                          </span>
                          <span *ngIf="file.printSettings.numOfCopies > 1">
                            <!-- copies -->
                            <span class="zx-text-tiny zx-text-sm-small">
                              {{ file.printSettings.numOfCopies }}
                            </span>
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                              {{ "printing-table.copies-short" | translate }}
                            </span>
                            <!-- , -->
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">,
                            </span>
                            <!-- price per page -->
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                              <span class="d-sm-none">
                                {{ "printing-table.price-per-copy.short" | translate }}
                              </span>
                              <span class="d-none d-sm-inline">
                                {{ "printing-table.price-per-copy" | translate }}
                              </span>
                            </span>
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">:</span>
                            <span class="zx-text-tiny">
                              {{
                              roundDownTowDecimal(
                              (!isPHOrder(order) ?
                              (file.price / file.printSettings.numOfCopies) :
                              (file.price.pricePerPage * file.price.pages))
                              )
                              }}
                            </span>
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                              {{ "printing-table.nis" | translate }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </span>
                    <!-- // calc file price -->

                    <!-- ----- download file [express] - 3D: SU/BMPH בלבד; 2D: כל מצב צפייה בהזמנות משתמש ----- -->
                    <div *ngIf="isManagementView" class="w-100 d-flex justify-content-end">
                      <div *ngIf="is3DOrder(order) && canDownload3DOrderFiles()"
                        (click)="onDownload3DFile(file)"
                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill text-center zx-bg-green-border-gray c-pointer"
                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">
                          {{ "su-management.users.download" | translate }}
                        </span>
                      </div>
                      <ng-container *ngIf="!is3DOrder(order)">
                        <div [matMenuTriggerFor]="downloadFileManuExpress"
                          class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill text-center zx-bg-green-border-gray c-pointer"
                          [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                          <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green" [class.zx-text-white]="isDarkMode">
                            {{ "su-management.users.download" | translate }}
                          </span>
                        </div>
                        <mat-menu #downloadFileManuExpress="matMenu">
                      <!-- download ORIGINAL -->
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                        (click)="onDownloadExpressUiFile(file, order, true)">
                        <b class="zx-text-small m-0">
                          {{'su-management.users.download-original' | translate}}
                        </b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">crop_original</mat-icon>
                      </button>
                      <!-- download PROCESSED NOT SENT (express only) -->
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                        (click)="onDownloadExpressUiFile(file, order, 'processedNotSent')">
                        <b class="zx-text-small m-0">
                          {{'su-management.users.download-processed-not-sent' | translate}}
                        </b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">edit_note</mat-icon>
                      </button>
                      <!-- download PRINTED -->
                      <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
                        [disabled]="order.status === 'PENDING'"
                        (click)="onDownloadExpressUiFile(file, order, false)">
                        <b class="zx-text-small m-0">
                          {{'su-management.users.download-printed' | translate}}
                        </b>
                        <mat-icon class="mx-1 p-0 zx-pt-small">file_copy</mat-icon>
                      </button>
                        </mat-menu>
                      </ng-container>
                    </div>
                    <!-- // ----- download file [express] ----- -->

                  </article>
                  <!-- // file date -->
                </article>
                <!-- // 1st line -->

                <!-- 2nd line -->
                <article *ngIf="shouldShowExpressFileSecondLine(file)" class="d-flex w-100 pt-1 row"
                  [class.zx-ltr]="!isRTL">
                  <article *ngFor="let gridItem of getExpressFileGridDisplayItems(file); let j = index; trackBy: trackByExpressGridItem"
                    [class.d-flex]="isExpressFileGridItemVisible(order, file, i, j)"
                    [class.d-none]="isExpressFileGridItemHidden(order, file, i, j)"
                    class="col-4 col-sm-3 col-md-2 pb-1 position-relative" style="max-width: max-content">
                    <article *ngIf="gridItem.type === 'partHeader'"
                      class="zx-order-summery-image-con d-flex flex-column align-items-center justify-content-between p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                      <b class="zx-text-tiny text-green text-center pt-1">
                        {{ getExpressChunkPartLabel(gridItem.partNumber) }}
                      </b>
                      <div *ngIf="file._isChunkedMerged && isManagementView" class="w-100 d-flex justify-content-center pb-1">
                        <ng-container *ngTemplateOutlet="expressChunkPartDownload; context: { partFile: gridItem.sourceFile, orderCtx: order }"></ng-container>
                      </div>
                    </article>
                    <article *ngIf="gridItem.type === 'image'"
                      class="zx-order-summery-image-con d-flex flex-column align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light"
                      [class.justify-content-center]="is3DOrder(order)"
                      [class.justify-content-between]="!is3DOrder(order)">
                      <!-- -----===----- thumbnail 2/2 [express] -----===----- -->
                      <div class="d-flex zx-medium-plus-icon-size rounded-1">
                        <!-- thumbnail 2/2 [express] - ב-3D אין תצוגה מקדימה -->
                        <img *ngIf="!expressImageErrors2[o][gridItem.sourceFileIndex][gridItem.sourcePageIndex]"
                          (error)="expressImageErrors2[o][gridItem.sourceFileIndex][gridItem.sourcePageIndex] = true"
                          (click)="!is3DOrder(order) && openPreviewDialogInner('express', order, gridItem.sourceFile, gridItem.sourcePageIndex, gridItem.sourceFile)"
                          class="w-100 h-100 object-fit-contain" [class.c-pointer]="!is3DOrder(order)"
                          [matTooltip]="is3DOrder(order) ? '' : ('printing-table.preview' | translate)"
                          [matTooltipPosition]="'above'"
                          [src]="getImgExpress(order, gridItem.image)" alt="File Page Image" />
                        <div *ngIf="expressImageErrors2[o][gridItem.sourceFileIndex][gridItem.sourcePageIndex]" class="d-flex flex-column align-items-center"
                          matTooltip="{{
                            'my-orders.no-img-src-explain' | translate
                          }}" matTooltipPosition="below" matTooltipClass="centered-tooltip">
                          <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg" />
                          <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                            [class.zx-text-white]="isDarkMode">
                            {{ "my-orders.no-img-src" | translate }}
                          </b>
                        </div>
                        <!-- // error finding image src? -->
                      </div>
                      <!-- -----===----- // thumbnail 2/2 [express] -----===----- -->

                      <div *ngIf="!is3DOrder(order)" class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                        <span class="zx-text-tiny">
                          <span *ngIf="!isPHOrder(order)">
                            {{
                            getExpressDimensions(
                            "h",
                            gridItem.image.imageHeight,
                            gridItem.image.imageWidth,
                            file.printSettings,
                            order.printerID?.consumables?.papers || [],
                            gridItem.image.origImageDPI
                            )
                            }}
                          </span>
                          <span *ngIf="isPHOrder(order)">
                            {{
                            getPHDimensions("h", order, file, gridItem.image)
                            }}
                          </span>
                          <span>×</span>
                          <span *ngIf="!isPHOrder(order)">
                            {{
                            getExpressDimensions(
                            "w",
                            gridItem.image.imageHeight,
                            gridItem.image.imageWidth,
                            file.printSettings,
                            order.printerID?.consumables?.papers || [],
                            gridItem.image.origImageDPI
                            )
                            }}
                          </span>
                          <span *ngIf="isPHOrder(order)">
                            {{
                            getPHDimensions("w", order, file, gridItem.image)
                            }}
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ "printing-table.dimensions-cm" | translate }}
                          </span>
                        </span>
                      </div>
                      <article class="position-absolute d-flex w-100 top-0" [class.flex-row-reverse]="!isRTL">
                        <span class="p-1 p-lg-2 zx-bg-light">
                          <div class="d-flex align-items-center text-green zx-text-tiny"
                            [class.flex-row-reverse]="isRTL">
                            <span>{{ getExpressFileImageSeqIndex(file, gridItem) + 1 }}</span>
                            <span>/</span>
                            <span>{{ getExpressFileImageCount(file) }}</span>
                          </div>
                        </span>
                      </article>
                      <ng-container *ngIf="shouldShowExpressPrinterStatus(order, file, gridItem)">
                      <ng-container *ngIf="getExpressPrinterStatusFile(file, gridItem) as statusFile">
                      <div *ngIf="isManagementView" class="d-flex top-0 w-100 position-absolute"
                        [class.justify-content-end]="isRTL"
                        [class.justify-content-start]="!isRTL">
                        <mat-icon *ngIf="!statusFile.error && (statusFile.sentToPrinter || statusFile.remote_id)"
                          class="zx-text-small text-green zx-text-sm-medium text-center pt-1"
                          [matTooltip]="'su-management.received-in-printer' | translate" matTooltipPosition="above">check</mat-icon>
                        <mat-icon *ngIf="!statusFile.error && !(statusFile.sentToPrinter || statusFile.remote_id)"
                          class="zx-text-small text-orange zx-text-sm-medium text-center pt-1"
                          [matTooltip]="'su-management.no-received-in-printer-yet' | translate" matTooltipPosition="above">error_outline</mat-icon>
                        <mat-icon *ngIf="statusFile.error" class="zx-text-small text-red zx-text-sm-medium text-center pt-1"
                          [matTooltip]="'su-management.rejected-by-printer' | translate" matTooltipPosition="above">error</mat-icon>
                      </div>
                      </ng-container>
                      </ng-container>
                    </article>
                  </article>
                  <article *ngIf="!isAllImagesExpanded(order, file, i) && getExpressFileDisplayItemCount(file) > 14"
                    class="col-4 col-sm-3 col-md-2 pb-1 c-pointer order-last" style="max-width: max-content"
                    (click)="showMoreImagesFor(order, file, i)">
                    <article mat-ripple
                      class="zx-order-summery-image-con d-flex flex-column gap-1 align-items-center justify-content-center p-1 p-lg-2 c-pointer rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light step-item-hover">
                      <span class="zx-text-tiny text-center text-green c-pointer" style="max-width: 90px">
                        <b>
                          {{ "my-orders.show" | translate }}
                        </b>
                        <b>
                          {{ getExpressFileDisplayItemCount(file) - 13 }}
                        </b>
                      </span>
                      <b class="zx-text-tiny text-center text-green c-pointer">
                        {{ "my-orders.more-pages" | translate }}
                      </b>
                    </article>
                  </article>
                  <article *ngIf="isAllImagesExpanded(order, file, i) && getExpressFileDisplayItemCount(file) > 14"
                    class="col-4 col-sm-3 col-md-2 pb-1 c-pointer order-last" style="max-width: max-content"
                    (click)="hideMoreImagesFor(order, file, i)">
                    <article mat-ripple
                      class="zx-order-summery-image-con d-flex flex-column gap-1 align-items-center justify-content-center p-1 p-lg-2 c-pointer rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light step-item-hover">
                      <span class="zx-text-tiny text-center text-green c-pointer" style="max-width: 90px">
                        <b>
                          {{ "my-orders.hide" | translate }}
                        </b>
                        <b>
                          {{ getExpressFileDisplayItemCount(file) - 13 }}
                        </b>
                      </span>
                      <b class="zx-text-tiny text-center text-green c-pointer">
                        {{ "my-orders.more-pages" | translate }}
                      </b>
                    </article>
                  </article>
                </article>
                <!-- // 2nd line -->
                <button *ngIf="canShareExpressFile(order, file)"
                  type="button"
                  class="my-orders-share-wall-btn my-orders-share-wall-btn--file-bottom"
                  [matTooltip]="'order-complited.wall.subtitle' | translate"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isShareWallTooltipDesktop()"
                  (click)="shareExpressFileToWall(order, file, $event)">
                  {{ 'my-orders.share-to-wall' | translate }}
                </button>
              </section>
              <!-- // ===== files ===== -->

              <!-- ===== fix products ===== -->
              <section ngClass="w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL" *ngFor="
                  let product of order.fix_products_order?.products;
                  index as i
                " class="d-flex w-100">
                <!-- 1st line -->
                <article class="d-flex align-items-center gap-2 gap-lg-3 w-100" [class.flex-row-reverse]="!isRTL">
                  <!-- product image -->
                  <article
                    class="zx-order-summery-image-con d-flex flex-column justify-content-center align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                    <img class="object-fit-contain zx-big-minus-icon-size" [src]="
                        'assets/images/fix-products/' +
                        product.productId.previewImage +
                        '.png'
                      " alt="Product Image" />
                  </article>
                  <!-- product date -->
                  <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">
                    <!-- [up container] -->
                    <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                      [class.flex-row-reverse]="!isRTL">
                      <!-- name -->
                      <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                        [class.zx-text-white]="isDarkMode">
                        <span>
                          <span>
                            {{
                            "fix-product." + product.productId.name
                            | translate
                            }}
                          </span>
                        </span>
                      </span>
                      <!-- total product price -->
                      <span class="px-1 px-lg-3" [class.zx-text-white]="isDarkMode">
                        <span class="zx-text-small">
                          {{
                          product.price
                          ? product.price * product.quantity
                          : product.productId.defaultPrice *
                          product.quantity
                          }}
                        </span>
                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                          {{ "printing-table.nis" | translate }}
                        </span>
                      </span>
                    </div>

                    <!-- [settings] -->
                    <div class="d-flex">
                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray flex-shrink-1"
                        [class.flex-sm-row]="isRTL" [class.flex-sm-row-reverse]="!isRTL">
                        <!-- one -->
                        <span *ngIf="product.quantity === 1"
                          class="zx-text-tiny zx-text-sm-small d-flex align-items-end">
                          <span>
                            {{ "su-management.units.one" | translate }}
                          </span>
                        </span>
                        <!-- many -->
                        <span *ngIf="product.quantity > 1" class="zx-text-tiny zx-text-sm-small d-flex align-items-end">
                          <span>{{
                            product.price
                            ? product.price
                            : product.productId.defaultPrice
                            }}</span>
                          <span class="zx-100-opp">.</span>
                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                          </span>
                          <span class="zx-100-opp">.</span>
                          <span>×</span>
                          <span class="zx-100-opp">.</span>
                          <span>{{ product.quantity }}</span>
                          <span class="zx-100-opp">.</span>
                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "su-management.units.short" | translate }}
                          </span>
                          <span class="zx-100-opp">.</span>
                          <span>=</span>
                          <span class="zx-100-opp">.</span>
                          <span>{{
                            (product.price
                            ? product.price
                            : product.productId.defaultPrice) *
                            product.quantity
                            }}</span>
                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                            {{ "printing-table.nis" | translate }}
                          </span>
                        </span>
                      </div>
                    </div>

                    <span class="zx-100-opacity">_</span>
                    <span class="zx-100-opacity d-sm-none">_</span>
                  </article>
                  <!-- // product date -->
                </article>
                <!-- // 1st line -->
              </section>
              <!-- // ===== fix products ===== -->

            </div>
          </div>
          <!-- //files [express/ph] ---------- files [express/ph] ---------- files [express]  -->

        </div>
        <!-- // SENT order content ============================= SENT order content ============================= SENT order content -->

        <mat-action-row *ngIf="
            !isEmptyFixProductsPaymentOrder(order) &&
            (order.status === 'PENDING' ||
              order.status === 'QR' ||
              order.status === 'NOT_PAID') &&
            !order.isDeleted &&
            !(order.collectionData && order.status === 'NOT_PAID' && order.files && order.files.length > 0)
          " class="align-items-center justify-content-center d-flex zx-choosen-order-action px-2"
          [class.ph-action-row-spacer]="isPHOrder(order)">
          <!-- PH: 2 כפתורים – רק במצב צפה בהזמנות משתמש/הזמנה (ללא צור הצעת מחיר) -->
          <div *ngIf="isPHOrder(order) && isManagementView" class="d-flex flex-wrap gap-2 justify-content-center align-items-center py-2 px-2 ph-order-action-buttons">
            <button mat-stroked-button color="primary" class="rounded-pill zx-text-tiny zx-text-sm-small"
              [routerLink]="isManagementView ? ['/chat/manager', order._id] : ['/chat/user', userChatUserId, order._id]">
              <mat-icon class="zx-text-small">chat</mat-icon>
              <span class="ms-1 d-none d-sm-inline">{{ "ph-order-action.chat-with-user" | translate }}</span>
              <span class="ms-1 d-inline d-sm-none">{{ "chat.title" | translate }}</span>
            </button>
            <button *ngIf="!isPhOrderCancelled(order)" mat-stroked-button color="warn" class="rounded-pill zx-text-tiny zx-text-sm-small"
              (click)="openDeleteOrderDialog($event, order); $event.stopPropagation()">
              <mat-icon class="zx-text-small">cancel</mat-icon>
              <span class="ms-1">{{ "ph-order-action.cancel-order" | translate }}</span>
            </button>
          </div>
          <!-- PH: כפתור צ'אט במצב רגיל – ההזמנות שלי -->
          <div *ngIf="isPHOrder(order) && !isManagementView" class="d-flex flex-wrap gap-2 justify-content-center align-items-center py-2 px-2 ph-order-action-buttons">
            <button mat-stroked-button color="primary" class="rounded-pill zx-text-tiny zx-text-sm-small"
              [routerLink]="isManagementView ? ['/chat/manager', order._id] : ['/chat/user', userChatUserId, order._id]">
              <mat-icon class="zx-text-small">chat</mat-icon>
              <span class="ms-1 d-none d-sm-inline">{{ "ph-order-action.chat-with-machine-operator-long" | translate }}</span>
              <span class="ms-1 d-inline d-sm-none">{{ "my-orders.chat-with-factory" | translate }}</span>
            </button>
          </div>
          <!-- NO, BUT POSSIBLE! (sent to print?) - לא PH -->
          <div *ngIf="!isPHOrder(order) && order.files && order.files.length > 0">
            <button mat-raised-button color="primary" class="print-button rounded-pill d-flex"
              (click)="openOrderSummaryDialog($event, order)">
              <span class="zx-text-tiny zx-text-sm-small px-3 px-lg-5">
                <span class="text-white">{{
                  "my-orders.send-to-print-this-order-1" | translate
                  }}</span>
                <span class="zx-100-opp">-</span>
                <span class="text-white">{{ order._id.slice(0, 8) }}</span>
                <span class="zx-100-opp">-</span>
                <span class="text-white">{{
                  "my-orders.send-to-print-this-order-2" | translate
                  }}</span>
              </span>
            </button>
          </div>
          <!-- NO, BUT NOT POSSIBLE! NO FILES! (sent to print?) - לא PH -->
          <div *ngIf="!isPHOrder(order) && (!order.files || order.files.length === 0)"
            class="d-flex w-100 flex-column flex-lg-row gap-2 gap-lg-0 align-items-center justify-content-lg-between">
            <b class="text-red zx-text-tiny px-lg-3" [class.zx-text-white]="isDarkMode">
              {{ "my-orders.contact-us-no-files-order" | translate }}
            </b>
            <b class="text-green zx-text-tiny px-lg-3">
              {{ "my-orders.contact-us-for-help-explain" | translate }}
            </b>
            <!-- [whatsup btn] -->
            <button mat-raised-button (click)="openWhatsApp()" class="rounded-pill zx-text-tiny zx-text-sm-small">
              <div class="w-100 h-100 d-flex align-items-center gap-2">
                <div class="whatsup-logo-container-small">
                  <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo-small" />
                </div>
                <span class="zx-text-tiny-tiny">
                  {{ "my-orders.contact-us-for-help" | translate }}
                </span>
              </div>
            </button>
          </div>
        </mat-action-row>
        <!-- PH: שורת מרווח כשהשורה העיקרית מוסתרת (למשל PAID, DONE) -->
        <mat-action-row *ngIf="isPHOrder(order) && !order.isDeleted &&
          !((order.status === 'PENDING' || order.status === 'QR' || order.status === 'NOT_PAID') &&
            !(order.collectionData && order.status === 'NOT_PAID' && order.files && order.files.length > 0))"
          class="align-items-center justify-content-center d-flex zx-choosen-order-action ph-action-row-spacer px-2">
          <!-- PH: 3 כפתורים – רק במצב צפה בהזמנות משתמש/הזמנה -->
          <div *ngIf="isManagementView" class="d-flex flex-wrap gap-2 justify-content-center align-items-center py-2 px-2 ph-order-action-buttons">
            <button mat-stroked-button color="primary" class="rounded-pill zx-text-tiny zx-text-sm-small"
              [routerLink]="isManagementView ? ['/chat/manager', order._id] : ['/chat/user', userChatUserId, order._id]">
              <mat-icon class="zx-text-small">chat</mat-icon>
              <span class="ms-1 d-none d-sm-inline">{{ "ph-order-action.chat-with-user" | translate }}</span>
              <span class="ms-1 d-inline d-sm-none">{{ "chat.title" | translate }}</span>
            </button>
            <button *ngIf="!isPhOrderCancelled(order)" mat-stroked-button color="warn" class="rounded-pill zx-text-tiny zx-text-sm-small"
              (click)="openDeleteOrderDialog($event, order); $event.stopPropagation()">
              <mat-icon class="zx-text-small">cancel</mat-icon>
              <span class="ms-1">{{ "ph-order-action.cancel-order" | translate }}</span>
            </button>
          </div>
          <!-- PH: IN_QUOTATION בלבד – משתמש: צ'אט + צפה בהצעת המחיר (מובייל: טקסט מקוצר) -->
          <div *ngIf="!isManagementView && order.status === 'IN_QUOTATION'" class="d-flex flex-wrap gap-2 justify-content-center align-items-center py-2 px-2 ph-order-action-buttons ph-in-quotation-buttons">
            <button mat-stroked-button color="primary" class="rounded-pill zx-text-tiny zx-text-sm-small ph-in-quotation-action-btn"
              [routerLink]="['/chat/user', userChatUserId, order._id]">
              <mat-icon class="zx-text-small">chat</mat-icon>
              <span class="ms-1 d-none d-sm-inline">{{ "ph-order-action.chat-with-machine-operator-long" | translate }}</span>
              <span class="ms-1 d-inline d-sm-none">{{ "chat.title" | translate }}</span>
            </button>
            <button mat-raised-button class="rounded-pill zx-text-tiny zx-text-sm-small ph-view-offer-btn ph-in-quotation-action-btn text-white"
              (click)="navigateToChat(order)">
              <span class="ms-1 d-none d-sm-inline">{{ "my-orders.view-offer-long" | translate }}</span>
              <span class="ms-1 d-inline d-sm-none">{{ "my-orders.view-offer" | translate }}</span>
            </button>
          </div>
          <!-- PH: כפתור צ'אט במצב רגיל – ההזמנות שלי (לא IN_QUOTATION) -->
          <div *ngIf="!isManagementView && order.status !== 'IN_QUOTATION'" class="d-flex flex-wrap gap-2 justify-content-center align-items-center py-2 px-2 ph-order-action-buttons">
            <button mat-stroked-button color="primary" class="rounded-pill zx-text-tiny zx-text-sm-small"
              [routerLink]="isManagementView ? ['/chat/manager', order._id] : ['/chat/user', userChatUserId, order._id]">
              <mat-icon class="zx-text-small">chat</mat-icon>
              <span class="ms-1 d-none d-sm-inline">{{ "ph-order-action.chat-with-machine-operator-long" | translate }}</span>
              <span class="ms-1 d-inline d-sm-none">{{ "my-orders.chat-with-factory" | translate }}</span>
            </button>
          </div>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    <!-- // orders accordion -->

    <!-- NO orders -->
    <div *ngIf="orders.length <= 0 && !isLoading"
      class="d-flex flex-column align-items-center justify-content-center gap-1 gap-sm-2 flex-grow-1">
      <p class="info-text mat-body-1">
        <span *ngIf="showOldOrderMessage">
          {{ "my-orders.old-order" | translate }}
        </span>
        <span *ngIf="!showOldOrderMessage && !isManagementView">
          {{ "my-orders.no-orders" | translate }}
        </span>
        <span *ngIf="!showOldOrderMessage && isManagementView">
          {{ "my-orders.no-orders.su" | translate }}
        </span>
      </p>
      <button *ngIf="!isManagementView && !showOldOrderMessage" class="rounded-pill zx-text-white" mat-raised-button color="primary"
        type="button" (click)="goToNewOrder()">
        {{ "main-nav.new-order" | translate }}
      </button>
    </div>
    <!-- // NO orders -->

    <span class="d-flex" style="min-height: 20px"></span>
  </section>
  <!-- // orders -------------------------------------------------------------------------------------------------------- // orders -->
</div>

<div class="p-2 d-flex flex-column gap-2" *ngIf="!(orders.length <= 0 && !isLoading) || (orderIdFromRoute && isManagementView)">
  <mat-paginator class="m-0" [length]="totalOrders" [pageSize]="ordersPerPage" [pageSizeOptions]="pageSizeOptions"
    (page)="onChangedPage($event)" *ngIf="orders.length > 0 && !orderIdFromRoute"></mat-paginator>
  <button *ngIf="orderIdFromRoute && isManagementView" class="w-100 rounded-pill" mat-stroked-button color="primary"
    type="button" (click)="goToAllUserOrders()">
    {{ "su-management.view-all-orders-of-user" | translate }}
  </button>
  <div>
    <button *ngIf="!isManagementView" class="w-100 rounded-pill fw-bold text-green" mat-flat-button type="button"
      [class.text-white]="isDarkMode" (click)="goToNewOrder()">
      {{ "main-nav.new-order" | translate }}
    </button>
  </div>
</div>

<div *ngIf="isManagementView" class="d-flex justify-content-between px-2 pb-2">
  <button class="rounded-pill" mat-stroked-button color="primary" type="button" (click)="goToUsersManagementOnUser()">
    {{ "su-management.users.show-user" | translate }}
  </button>
  <button class="rounded-pill" mat-stroked-button color="primary" type="button" (click)="goToOrdersManagement()">
    {{ "su-management.orders-management" | translate }}
  </button>
</div>